var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Verifyed_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Verifyed_20",
    "data-name": "Verifyed \\u2013 20",
    clipPath: "url(#clip-Verifyed_20)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#f8f8f8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 1707,
    height: 891,
    transform: "translate(107 95)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19534",
    "data-name": "Group 19534",
    transform: "translate(1345.145 77.74)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19533",
    "data-name": "Group 19533",
    transform: "translate(350.285 52.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19532",
    "data-name": "Group 19532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51765",
    "data-name": "Path 51765",
    d: "M459.2,74.292A64.517,64.517,0,0,1,473.2,84.151l14.953-5.323L502.2,101.012l-11.2,11.248a64.392,64.392,0,0,1,2.938,16.868l14.332,6.809-5.75,25.623-15.865.036A64.184,64.184,0,0,1,476.8,175.59l5.323,14.955L459.941,204.6l-11.25-11.2a64.354,64.354,0,0,1-16.868,2.933l-6.8,14.334-25.628-5.748-.034-15.867a64.234,64.234,0,0,1-14-9.861l-14.955,5.325L356.35,162.335l11.2-11.25a64.544,64.544,0,0,1-2.938-16.865l-14.33-6.806,5.748-25.628,15.865-.031a64.207,64.207,0,0,1,9.861-14L376.436,72.8l22.179-14.053,11.25,11.2a64.282,64.282,0,0,1,16.87-2.936l6.8-14.332,25.623,5.748.038,15.865Zm-22.593,30.155A28.172,28.172,0,1,0,457.931,138.1,28.171,28.171,0,0,0,436.608,104.446Z",
    transform: "translate(-350.285 -52.679)",
    fill: "#ebebeb",
    fillRule: "evenodd"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    transform: "translate(1321.989 50.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19661",
    "data-name": "Group 19661",
    transform: "translate(402.469 269.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19657",
    "data-name": "Group 19657",
    transform: "translate(0 35.972)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19505",
    "data-name": "Rectangle 19505",
    width: 13.805,
    height: 44.603,
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19658",
    "data-name": "Group 19658",
    transform: "translate(25.412 17.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19506",
    "data-name": "Rectangle 19506",
    width: 13.806,
    height: 62.959,
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19659",
    "data-name": "Group 19659",
    transform: "translate(52.459 9.043)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19507",
    "data-name": "Rectangle 19507",
    width: 13.806,
    height: 71.532,
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19660",
    "data-name": "Group 19660",
    transform: "translate(79.506)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19508",
    "data-name": "Rectangle 19508",
    width: 13.805,
    height: 80.574,
    fill: "#097bed"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(1370 576.74) scale(0.285, 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19537",
    "data-name": "Group 19537",
    transform: "translate(19.855 444.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51768",
    "data-name": "Path 51768",
    d: "M1709.7,444.82c0,.144-378.317.261-844.883.261-466.732,0-844.965-.117-844.965-.261s378.232-.26,844.965-.26C1331.386,444.56,1709.7,444.676,1709.7,444.82Z",
    transform: "translate(-19.855 -444.56)",
    fill: "#455a64",
    style: {}
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(1390.145 569.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19845",
    "data-name": "Group 19845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19767",
    "data-name": "Group 19767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19764",
    "data-name": "Group 19764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51851",
    "data-name": "Path 51851",
    d: "M359.533,266.065a9.765,9.765,0,0,0,7.064-9.745c-.122-1.957-.85-3.861-.766-5.82.13-3.041,2.148-5.611,3.666-8.248s2.537-6.116.767-8.592c-1.148-1.606-3.175-2.33-4.565-3.731-1.361-1.372-2.007-3.273-2.736-5.062s-1.674-3.636-3.353-4.592-4.254-.531-4.936,1.277",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51852",
    "data-name": "Path 51852",
    d: "M341.367,216.736c2.995-1.9,3.719-6.313,2.1-9.468s-5.068-5.071-8.571-5.636a16.331,16.331,0,0,0-14.07,4.662c-1.933,1.991-3.5,4.588-6.12,5.5-2.3.8-4.854.078-7.273.392a10.974,10.974,0,0,0-7.686,5.542,23.684,23.684,0,0,0-2.733,9.347c-.353,2.981-.586,6.252-2.654,8.427-2.016,2.122-5.2,2.571-7.71,4.08A10.554,10.554,0,0,0,283.511,254c.993,1.448,2.418,2.776,2.533,4.528.1,1.6-.929,3.024-1.413,4.552a7.122,7.122,0,0,0,6.094,8.845c2.08.12,4.309-.691,6.174.239s2.541,3.157,3.726,4.854a8.906,8.906,0,0,0,10.86,2.8c1.53-.75,2.975-1.989,4.675-1.874s3.033,1.563,4.7,1.886c2.186.423,4.262-1.187,5.561-2.995s2.206-3.937,3.869-5.416c2.178-1.937,5.238-2.416,7.994-3.365a22.55,22.55,0,0,0,12.734-31.589",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19763",
    "data-name": "Group 19763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19762",
    "data-name": "Group 19762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19761",
    "data-name": "Group 19761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19760",
    "data-name": "Group 19760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19747",
    "data-name": "Group 19747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19746",
    "data-name": "Group 19746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19745",
    "data-name": "Group 19745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19690",
    "data-name": "Group 19690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19689",
    "data-name": "Group 19689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19688",
    "data-name": "Group 19688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19687",
    "data-name": "Group 19687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19686",
    "data-name": "Group 19686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19685",
    "data-name": "Group 19685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51853",
    "data-name": "Path 51853",
    d: "M347.947,220.67a4.79,4.79,0,0,1,4.274,4.866h0l-2.857,64.672c-.12,7.638-11.285,11.93-19.462,11.74h0c-8.258-.192-8.525-4.242-8.628-11.509-.172-12.14-.158-16.7-.162-16.628,0,0-10.432-1.756-12.564-15.376-1.06-6.773-.7-17.874-.1-26.947.532-8.167,5.966-18.177,14.1-17.3Z",
    fill: "#ffbe9d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19704",
    "data-name": "Group 19704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19696",
    "data-name": "Group 19696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19695",
    "data-name": "Group 19695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19694",
    "data-name": "Group 19694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19693",
    "data-name": "Group 19693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19692",
    "data-name": "Group 19692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19691",
    "data-name": "Group 19691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51854",
    "data-name": "Path 51854",
    d: "M311.441,240.3a1.746,1.746,0,0,0,1.68,1.766,1.67,1.67,0,0,0,1.8-1.571,1.747,1.747,0,0,0-1.678-1.766A1.671,1.671,0,0,0,311.441,240.3Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19703",
    "data-name": "Group 19703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19702",
    "data-name": "Group 19702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19701",
    "data-name": "Group 19701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19700",
    "data-name": "Group 19700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19699",
    "data-name": "Group 19699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19698",
    "data-name": "Group 19698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19697",
    "data-name": "Group 19697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51855",
    "data-name": "Path 51855",
    d: "M310.84,237.268c.216.228,1.541-.748,3.42-.739,1.877-.017,3.254.952,3.458.723.1-.1-.119-.513-.719-.952a4.794,4.794,0,0,0-2.767-.86,4.6,4.6,0,0,0-2.723.873C310.93,236.755,310.734,237.166,310.84,237.268Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19718",
    "data-name": "Group 19718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19710",
    "data-name": "Group 19710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19709",
    "data-name": "Group 19709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19708",
    "data-name": "Group 19708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19707",
    "data-name": "Group 19707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19706",
    "data-name": "Group 19706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19705",
    "data-name": "Group 19705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51856",
    "data-name": "Path 51856",
    d: "M330.17,240.3a1.746,1.746,0,0,0,1.68,1.766,1.67,1.67,0,0,0,1.8-1.571,1.747,1.747,0,0,0-1.678-1.766A1.671,1.671,0,0,0,330.17,240.3Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19717",
    "data-name": "Group 19717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19716",
    "data-name": "Group 19716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19715",
    "data-name": "Group 19715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19714",
    "data-name": "Group 19714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19713",
    "data-name": "Group 19713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19712",
    "data-name": "Group 19712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19711",
    "data-name": "Group 19711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51857",
    "data-name": "Path 51857",
    d: "M329.308,237.66c.217.228,1.543-.748,3.421-.739,1.877-.018,3.254.952,3.458.722.1-.1-.117-.513-.719-.951a4.789,4.789,0,0,0-2.767-.86,4.6,4.6,0,0,0-2.723.872C329.4,237.146,329.2,237.557,329.308,237.66Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19725",
    "data-name": "Group 19725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19724",
    "data-name": "Group 19724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19723",
    "data-name": "Group 19723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19722",
    "data-name": "Group 19722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19721",
    "data-name": "Group 19721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19720",
    "data-name": "Group 19720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19719",
    "data-name": "Group 19719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51858",
    "data-name": "Path 51858",
    d: "M322.459,251.579a12.436,12.436,0,0,0-3.051-.557c-.48-.051-.933-.147-1.014-.475a2.443,2.443,0,0,1,.324-1.421q.681-1.74,1.427-3.651c1.982-5.2,3.418-9.471,3.208-9.549s-1.988,4.072-3.969,9.269c-.477,1.282-.934,2.5-1.368,3.672a2.785,2.785,0,0,0-.253,1.883,1.208,1.208,0,0,0,.788.7,3.287,3.287,0,0,0,.814.115A12.2,12.2,0,0,0,322.459,251.579Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19731",
    "data-name": "Group 19731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19730",
    "data-name": "Group 19730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19729",
    "data-name": "Group 19729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19728",
    "data-name": "Group 19728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19727",
    "data-name": "Group 19727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19726",
    "data-name": "Group 19726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51859",
    "data-name": "Path 51859",
    d: "M321.112,273.811a34.63,34.63,0,0,0,18.244-4.824s-4.621,9.6-18.244,8.3Z",
    fill: "#eb996e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19737",
    "data-name": "Group 19737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19736",
    "data-name": "Group 19736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19735",
    "data-name": "Group 19735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19734",
    "data-name": "Group 19734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19733",
    "data-name": "Group 19733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19732",
    "data-name": "Group 19732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51860",
    "data-name": "Path 51860",
    d: "M323.243,256.109a3.387,3.387,0,0,1,3.038-1.251,3.094,3.094,0,0,1,2.132,1.15,1.958,1.958,0,0,1,.144,2.24,2.271,2.271,0,0,1-2.464.617,7.108,7.108,0,0,1-2.4-1.438,2.081,2.081,0,0,1-.535-.557.627.627,0,0,1,0-.7",
    fill: "#e8505b"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19744",
    "data-name": "Group 19744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19743",
    "data-name": "Group 19743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19742",
    "data-name": "Group 19742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19741",
    "data-name": "Group 19741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19740",
    "data-name": "Group 19740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19739",
    "data-name": "Group 19739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19738",
    "data-name": "Group 19738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51861",
    "data-name": "Path 51861",
    d: "M327.985,252.891c-.3-.018-.314,2.021-2.063,3.465s-3.919,1.214-3.935,1.5c-.029.128.483.4,1.4.425a5.079,5.079,0,0,0,3.286-1.137,4.425,4.425,0,0,0,1.6-2.9C328.351,253.385,328.125,252.88,327.985,252.891Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19753",
    "data-name": "Group 19753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19752",
    "data-name": "Group 19752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19751",
    "data-name": "Group 19751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19750",
    "data-name": "Group 19750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19749",
    "data-name": "Group 19749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19748",
    "data-name": "Group 19748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51862",
    "data-name": "Path 51862",
    d: "M328.471,234.368c.184.511,2.06.273,4.264.544,2.21.226,3.986.876,4.279.418.131-.219-.178-.7-.9-1.2a7.47,7.47,0,0,0-6.509-.733C328.8,233.725,328.391,234.125,328.471,234.368Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19759",
    "data-name": "Group 19759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19758",
    "data-name": "Group 19758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19757",
    "data-name": "Group 19757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19756",
    "data-name": "Group 19756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19755",
    "data-name": "Group 19755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19754",
    "data-name": "Group 19754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51863",
    "data-name": "Path 51863",
    d: "M311.543,231.832c.329.427,1.625-.013,3.181-.03,1.556-.072,2.874.293,3.179-.153.133-.216-.074-.644-.649-1.049a4.607,4.607,0,0,0-5.124.147C311.579,231.184,311.4,231.623,311.543,231.832Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_51864",
    "data-name": "Path 51864",
    d: "M339.01,216.242a13.218,13.218,0,0,1,10.792-2.021c3.632,1.043,6.642,4.316,6.765,8.016.079,2.4-.959,4.962.108,7.131,1.016,2.064,3.519,2.9,5.294,4.4a8.125,8.125,0,0,1,1.881,9.824c-1.486,2.729-4.612,4.73-4.874,7.811-.247,2.9,2.2,5.345,2.791,8.2.657,3.144-1.084,6.4-3.579,8.483s-5.646,3.235-8.727,4.344c-2.4.865-4.977,1.743-7.472,1.177a7.649,7.649,0,0,1-5.6-6.386A10.409,10.409,0,0,1,339.224,259c1.749-1.925,4.2-3.562,4.621-6.1.655-3.959-4.063-7.213-3.772-11.213.15-2.063,1.605-3.771,2.816-5.467s2.267-3.83,1.524-5.767c-.966-2.517-4.274-3.173-6.273-5.019a6.113,6.113,0,0,1-1.67-6.192,6.3,6.3,0,0,1,4.936-4.208",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51865",
    "data-name": "Path 51865",
    d: "M340.474,213.172a9.315,9.315,0,0,1-10.99,9.2c-2.08-.38-4.359-1.432-6.16-.323-1.894,1.165-1.972,4.02-3.652,5.478-2.4,2.083-6.216.128-9.263,1.032-2.353.7-3.823,2.947-5.386,4.839s-3.9,3.691-6.258,2.993a27.607,27.607,0,0,1,.934-6.278A9.279,9.279,0,0,1,303.264,225a34.611,34.611,0,0,0,3.009-1.751c1.953-1.577,2.406-4.321,3.612-6.523a10.206,10.206,0,0,1,7.777-5.159c2.678-.274,5.438.53,8.049-.129,1.93-.486,3.615-1.739,5.571-2.11,3.807-.724,7.347,2.008,10.107,4.729",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19765",
    "data-name": "Group 19765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51866",
    "data-name": "Path 51866",
    d: "M365.343,245.719a2.954,2.954,0,0,0,.3-1.57,3.953,3.953,0,0,0-2.741-3.132,20.238,20.238,0,0,0-2.993-.806,8.76,8.76,0,0,1-3.39-1.4,4.776,4.776,0,0,1-1.764-3.642,38.432,38.432,0,0,1,.21-4.287,9.8,9.8,0,0,0-.107-2.1,4.472,4.472,0,0,0-.8-1.787,6.84,6.84,0,0,0-3.278-1.881,14.76,14.76,0,0,1-3.338-1.439,11.748,11.748,0,0,1-4.865-5.889,7.942,7.942,0,0,1-.349-1.192,1.349,1.349,0,0,1-.061-.429c.047-.013.182.568.6,1.546a12.118,12.118,0,0,0,2.483,3.7,12.288,12.288,0,0,0,5.685,3.249,7.23,7.23,0,0,1,3.522,2.015,4.956,4.956,0,0,1,.914,2.008,10.185,10.185,0,0,1,.119,2.22,40.486,40.486,0,0,0-.221,4.228,4.3,4.3,0,0,0,1.55,3.3,8.473,8.473,0,0,0,3.195,1.355,19.53,19.53,0,0,1,3.034.886,4.783,4.783,0,0,1,2.11,1.584,3.623,3.623,0,0,1,.692,1.871,2.377,2.377,0,0,1-.246,1.234A.957.957,0,0,1,365.343,245.719Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19766",
    "data-name": "Group 19766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51867",
    "data-name": "Path 51867",
    d: "M285.146,254.216a.862.862,0,0,1-.223-.105,1.51,1.51,0,0,1-.511-.515,2.75,2.75,0,0,1,.278-2.689,3.58,3.58,0,0,1,1.458-1.4,18.766,18.766,0,0,1,2.189-.924,6.753,6.753,0,0,0,2.29-1.3,4.9,4.9,0,0,0,1.308-2.582c.23-1.023.3-2.139.482-3.3a7.247,7.247,0,0,1,1.351-3.432c1.586-2.09,4.184-3.2,6.123-5.159a9.432,9.432,0,0,0,2.127-3.606,24.82,24.82,0,0,0,.963-4.36c.421-2.991.845-6.343,2.859-9.08a6.633,6.633,0,0,1,4.108-2.654,14.412,14.412,0,0,1,4.741.119,17.216,17.216,0,0,0,4.43.259,5.766,5.766,0,0,0,3.62-1.869c1.858-2,2.926-4.7,5.21-6.084a8.7,8.7,0,0,1,6.878-.948,7.626,7.626,0,0,1,4.528,3.519,8.572,8.572,0,0,1,1.176,4.2,7.373,7.373,0,0,1-.435,2.724,4.563,4.563,0,0,1-.4.873c-.026-.012.12-.31.3-.906a7.737,7.737,0,0,0,.332-2.685,8.463,8.463,0,0,0-1.223-4.055,7.336,7.336,0,0,0-4.377-3.314,8.342,8.342,0,0,0-6.548.957,9.575,9.575,0,0,0-2.627,2.712,30.325,30.325,0,0,1-2.466,3.338,6.78,6.78,0,0,1-1.739,1.362,6.445,6.445,0,0,1-2.165.67,17.575,17.575,0,0,1-4.563-.247,14.041,14.041,0,0,0-4.571-.116,6.113,6.113,0,0,0-3.793,2.46,12.6,12.6,0,0,0-1.946,4.268,41.974,41.974,0,0,0-.825,4.575,25.121,25.121,0,0,1-1,4.445,9.9,9.9,0,0,1-2.254,3.78c-2.053,2.034-4.626,3.12-6.122,5.085a6.825,6.825,0,0,0-1.3,3.236c-.193,1.134-.271,2.258-.52,3.317a5.231,5.231,0,0,1-1.439,2.741,7,7,0,0,1-2.415,1.33,19.053,19.053,0,0,0-2.176.87,3.392,3.392,0,0,0-1.4,1.281,2.665,2.665,0,0,0-.359,2.534A2.215,2.215,0,0,0,285.146,254.216Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19818",
    "data-name": "Group 19818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51868",
    "data-name": "Path 51868",
    d: "M251.735,347.951l24.152-2.214s14.863-39.146,33.185-48.639l11.868,20.731-25.4,47.735H245.929Z",
    fill: "#097bed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51869",
    "data-name": "Path 51869",
    d: "M251.735,347.951l24.152-2.214s14.863-39.146,33.185-48.639l11.868,20.731-25.4,47.735H245.929Z",
    transform: "translate(0.346)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19768",
    "data-name": "Group 19768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51870",
    "data-name": "Path 51870",
    d: "M261.278,359.006a37.244,37.244,0,0,1,4.518-7.556,37.369,37.369,0,0,1-4.518,7.556Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19769",
    "data-name": "Group 19769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51871",
    "data-name": "Path 51871",
    d: "M278.389,358.532a37.031,37.031,0,0,1-5.5-6.837,37.121,37.121,0,0,1,5.5,6.837Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19770",
    "data-name": "Group 19770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51872",
    "data-name": "Path 51872",
    d: "M281.36,349.555a19.414,19.414,0,0,1,0-6.333,19.411,19.411,0,0,1,0,6.333Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19771",
    "data-name": "Group 19771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51873",
    "data-name": "Path 51873",
    d: "M272.86,363.555a6.651,6.651,0,0,1-2.309-1.2c-1.2-.782-2.1-1.514-2.024-1.634a6.648,6.648,0,0,1,2.309,1.2C272.032,362.7,272.939,363.435,272.86,363.555Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19772",
    "data-name": "Group 19772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51874",
    "data-name": "Path 51874",
    d: "M286.727,327.57a41.848,41.848,0,0,1-3.812,8.51,41.93,41.93,0,0,1,3.812-8.51Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19773",
    "data-name": "Group 19773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51875",
    "data-name": "Path 51875",
    d: "M296.516,311.707c.087.115-.777.915-1.928,1.788a6.791,6.791,0,0,1-2.243,1.373c-.087-.114.776-.915,1.928-1.788A6.832,6.832,0,0,1,296.516,311.707Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_51876",
    "data-name": "Path 51876",
    d: "M332.641,362.469,345.1,312.162a17.113,17.113,0,0,1,19.647-12.729h0A17.112,17.112,0,0,1,378.618,318.9l-7.626,49.168a24.6,24.6,0,0,1-20.41,19.9l-9.9,1.545Z",
    fill: "#0093ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19774",
    "data-name": "Group 19774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51877",
    "data-name": "Path 51877",
    d: "M371.895,296.183a11.242,11.242,0,0,0-4.443-2.233,11.845,11.845,0,0,0-5.361.037,14.544,14.544,0,0,0-5.828,3.039c-3.651,3.06-5.637,7.036-6.987,9.821-.667,1.415-1.175,2.578-1.538,3.377a6.946,6.946,0,0,1-.608,1.223,6.763,6.763,0,0,1,.421-1.3c.3-.824.762-2.01,1.39-3.453a37.372,37.372,0,0,1,2.561-4.909,21.838,21.838,0,0,1,4.428-5.16,14.658,14.658,0,0,1,6.052-3.106,11.853,11.853,0,0,1,5.558.073,9.463,9.463,0,0,1,3.375,1.63,6.371,6.371,0,0,1,.756.684C371.831,296.076,371.908,296.17,371.895,296.183Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19775",
    "data-name": "Group 19775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51878",
    "data-name": "Path 51878",
    d: "M301.329,307.5a2.409,2.409,0,0,1-.348.467l-1.066,1.276c-.921,1.109-2.237,2.731-3.737,4.826a51.436,51.436,0,0,0-8.5,18.053c-1.737,7.671-1.823,14.855-2.118,20-.124,2.58-.245,4.668-.356,6.109-.06.674-.108,1.222-.147,1.658a2.473,2.473,0,0,1-.087.576,2.4,2.4,0,0,1-.017-.582c.012-.437.029-.988.049-1.663.047-1.514.112-3.585.19-6.113.2-5.145.225-12.355,1.979-20.1a49.709,49.709,0,0,1,8.714-18.153c1.546-2.078,2.91-3.67,3.881-4.742.481-.54.878-.939,1.141-1.214A2.458,2.458,0,0,1,301.329,307.5Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_51879",
    "data-name": "Path 51879",
    d: "M381.15,307.394c-1.366-9-6.335-11.155-11.48-13.956-1.683-.915-9.793-3-16.223-4.565-.614-3.9-1.715-10.87-1.957-12.343-.339-2.068-32.756,3.1-33.166,3.879-.273.514-1.019,8.592-1.491,13.976l-7.761,2.713-10.13,12.879-5.272,7.487a40.348,40.348,0,0,0-6.53,14.373,78.455,78.455,0,0,0-1.453,17.42l-1.566,33.026,67.826,19.179,5.251-33.455,17.5-23.819C376.19,334.555,382.831,318.455,381.15,307.394Z",
    fill: "#097bed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19776",
    "data-name": "Group 19776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51880",
    "data-name": "Path 51880",
    d: "M323.263,295.424a10.493,10.493,0,0,1-.451-2.291c-.212-1.424-.47-3.394-.723-5.574q-.176-1.618-.336-3.076a21.611,21.611,0,0,1-.179-2.543,3.052,3.052,0,0,1,.483-1.69c.262-.34.486-.432.5-.41s-.145.182-.328.518a3.254,3.254,0,0,0-.287,1.585c.018.693.174,1.539.288,2.485.119.968.245,1.994.377,3.071.252,2.18.452,4.157.571,5.591A10.431,10.431,0,0,1,323.263,295.424Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19777",
    "data-name": "Group 19777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51881",
    "data-name": "Path 51881",
    d: "M331.911,293.38a7.838,7.838,0,0,1-.721-2.1,33.568,33.568,0,0,1-.981-10.621,7.892,7.892,0,0,1,.325-2.194c.161.013-.133,3.376.259,7.5C331.162,290.085,332.067,293.338,331.911,293.38Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19778",
    "data-name": "Group 19778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51882",
    "data-name": "Path 51882",
    d: "M348.006,291.041a25.505,25.505,0,0,0-2.521-14.546,6.74,6.74,0,0,1,1.188,1.882,18.941,18.941,0,0,1,1.819,10.491A6.734,6.734,0,0,1,348.006,291.041Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19779",
    "data-name": "Group 19779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51883",
    "data-name": "Path 51883",
    d: "M301.949,320.456a31.141,31.141,0,0,1,5.948-7.929,99.178,99.178,0,0,1-5.948,7.929Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19780",
    "data-name": "Group 19780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51884",
    "data-name": "Path 51884",
    d: "M317.226,308.03a32.37,32.37,0,0,1-4.98-6.515,32.447,32.447,0,0,1,4.98,6.515Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19781",
    "data-name": "Group 19781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51885",
    "data-name": "Path 51885",
    d: "M333.193,300.222a120.852,120.852,0,0,1-6.5,6.333,23.832,23.832,0,0,1,6.5-6.333Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19782",
    "data-name": "Group 19782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51886",
    "data-name": "Path 51886",
    d: "M328.709,290.7a18.934,18.934,0,0,1-4.637-4.2,18.934,18.934,0,0,1,4.637,4.2Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19783",
    "data-name": "Group 19783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51887",
    "data-name": "Path 51887",
    d: "M342.7,283.243a23.637,23.637,0,0,1-6.841,1.465,23.549,23.549,0,0,1,6.841-1.465Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19784",
    "data-name": "Group 19784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51888",
    "data-name": "Path 51888",
    d: "M345.5,305.39a23.709,23.709,0,0,1-.354-7,23.712,23.712,0,0,1,.354,7Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19785",
    "data-name": "Group 19785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51889",
    "data-name": "Path 51889",
    d: "M340.395,316.042a37.287,37.287,0,0,1-3.013-8.268,37.332,37.332,0,0,1,3.013,8.268Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19786",
    "data-name": "Group 19786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51890",
    "data-name": "Path 51890",
    d: "M326.54,323.55a41.539,41.539,0,0,1-3.363-8.655,41.395,41.395,0,0,1,3.363,8.655Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19787",
    "data-name": "Group 19787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51891",
    "data-name": "Path 51891",
    d: "M313.5,332.061a36.079,36.079,0,0,1-1.737-8.485,36.215,36.215,0,0,1,1.737,8.485Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19788",
    "data-name": "Group 19788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51892",
    "data-name": "Path 51892",
    d: "M298,332.4a34.814,34.814,0,0,1-3.722-7.64A34.816,34.816,0,0,1,298,332.4Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19789",
    "data-name": "Group 19789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51893",
    "data-name": "Path 51893",
    d: "M297.667,342.335a41.709,41.709,0,0,1-8.353,4.126,41.853,41.853,0,0,1,8.353-4.126Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19790",
    "data-name": "Group 19790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51894",
    "data-name": "Path 51894",
    d: "M297.86,358.055a17.875,17.875,0,0,1-2-7.5,79.254,79.254,0,0,1,2,7.5Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19791",
    "data-name": "Group 19791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51895",
    "data-name": "Path 51895",
    d: "M294.655,369.1a33.742,33.742,0,0,1-6.179-5.654,33.841,33.841,0,0,1,6.179,5.654Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19792",
    "data-name": "Group 19792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51896",
    "data-name": "Path 51896",
    d: "M315.072,361.563c.038.149-2.258.805-4.938,1.987s-4.726,2.413-4.81,2.283a21.1,21.1,0,0,1,9.748-4.27Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19793",
    "data-name": "Group 19793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51897",
    "data-name": "Path 51897",
    d: "M309.1,356.087a26.659,26.659,0,0,1-2.445-7.019,26.6,26.6,0,0,1,2.445,7.019Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19794",
    "data-name": "Group 19794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51898",
    "data-name": "Path 51898",
    d: "M321.214,342.568a59.256,59.256,0,0,1-5.916,9.386,59.262,59.262,0,0,1,5.916-9.386Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19795",
    "data-name": "Group 19795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51899",
    "data-name": "Path 51899",
    d: "M334.225,343.865a30.815,30.815,0,0,1-5.765-9.611c.136-.064,1.3,2.158,2.889,4.8S334.346,343.775,334.225,343.865Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19796",
    "data-name": "Group 19796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51900",
    "data-name": "Path 51900",
    d: "M342.021,331.023a15.362,15.362,0,0,1-7.662.38,216.155,216.155,0,0,1,7.662-.38Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19797",
    "data-name": "Group 19797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51901",
    "data-name": "Path 51901",
    d: "M360.529,316.392A59.419,59.419,0,0,1,350.5,321.17a59.318,59.318,0,0,1,10.027-4.778Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19798",
    "data-name": "Group 19798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51902",
    "data-name": "Path 51902",
    d: "M361.76,307.088a38.513,38.513,0,0,1,3.973-8.013,38.648,38.648,0,0,1-3.973,8.013Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19799",
    "data-name": "Group 19799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51903",
    "data-name": "Path 51903",
    d: "M373.523,314.389A32.866,32.866,0,0,1,372,309.84a32.826,32.826,0,0,1-1.345-4.605,26.988,26.988,0,0,1,2.864,9.154Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19800",
    "data-name": "Group 19800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51904",
    "data-name": "Path 51904",
    d: "M375.365,324.07a23.492,23.492,0,0,1-9.007,2.308,190.878,190.878,0,0,1,9.007-2.308Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19801",
    "data-name": "Group 19801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51905",
    "data-name": "Path 51905",
    d: "M355.213,335.892c-.151-.03.278-2.464.4-5.494s-.084-5.49.069-5.508a22.452,22.452,0,0,1-.468,11Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19802",
    "data-name": "Group 19802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51906",
    "data-name": "Path 51906",
    d: "M351.193,348.055a24.665,24.665,0,0,1-6.5-7.833c.127-.083,1.45,1.771,3.243,3.923S351.3,347.946,351.193,348.055Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19803",
    "data-name": "Group 19803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51907",
    "data-name": "Path 51907",
    d: "M371.4,345.495a41.36,41.36,0,0,1-8.541,3.567,41.214,41.214,0,0,1,8.541-3.567Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19804",
    "data-name": "Group 19804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51908",
    "data-name": "Path 51908",
    d: "M364.163,368.388a58.082,58.082,0,0,1,.11-11,58.306,58.306,0,0,1-.11,11Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19805",
    "data-name": "Group 19805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51909",
    "data-name": "Path 51909",
    d: "M348.647,367.074a31.857,31.857,0,0,1,2.773-11.056c.141.05-.62,2.484-1.379,5.53S348.8,367.1,348.647,367.074Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19806",
    "data-name": "Group 19806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51910",
    "data-name": "Path 51910",
    d: "M349.362,373.081c.008.15-2.485.389-5.524.9s-5.478,1.073-5.519.928a29.393,29.393,0,0,1,11.043-1.823Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19807",
    "data-name": "Group 19807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51911",
    "data-name": "Path 51911",
    d: "M332.2,369.229a39.683,39.683,0,0,1,6.305-6.527,39.58,39.58,0,0,1-6.305,6.527Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19808",
    "data-name": "Group 19808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51912",
    "data-name": "Path 51912",
    d: "M321.087,380.043a36.483,36.483,0,0,1-1.351-3.913,36.441,36.441,0,0,1-1.4-3.9,15.985,15.985,0,0,1,2.749,7.81Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19809",
    "data-name": "Group 19809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51913",
    "data-name": "Path 51913",
    d: "M339.027,386.222a55.535,55.535,0,0,1-9.822-4.36,55.535,55.535,0,0,1,9.822,4.36Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19810",
    "data-name": "Group 19810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51914",
    "data-name": "Path 51914",
    d: "M307.756,384.409a27.432,27.432,0,0,1,2.376-7.153,27.4,27.4,0,0,1-2.376,7.153Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19811",
    "data-name": "Group 19811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51915",
    "data-name": "Path 51915",
    d: "M328.359,387.9c-.029.152-2.873-.309-6.409-.49s-6.412-.039-6.424-.193a31.172,31.172,0,0,1,12.833.683Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19812",
    "data-name": "Group 19812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51916",
    "data-name": "Path 51916",
    d: "M332.641,358.408a1.18,1.18,0,0,1-.027-.394,3.709,3.709,0,0,1,.161-1.135,2.511,2.511,0,0,1,1.087-1.488,3.493,3.493,0,0,1,2.441-.4l-.2.119c1.1-3.835,2.843-9.438,4.593-15.716,1.639-5.878,2.744-11.292,3.52-15.217l.916-4.65a11.234,11.234,0,0,1,.4-1.695,11.008,11.008,0,0,1-.2,1.73c-.157,1.109-.412,2.709-.753,4.683a156.541,156.541,0,0,1-3.38,15.287c-1.754,6.3-3.565,11.876-4.762,15.68l-.047.148-.158-.029a3.244,3.244,0,0,0-2.223.3,2.34,2.34,0,0,0-1.049,1.315A13.848,13.848,0,0,0,332.641,358.408Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19813",
    "data-name": "Group 19813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51917",
    "data-name": "Path 51917",
    d: "M355.064,372.317c-.085.039-.7-1.315-1.972-3.333a34.377,34.377,0,0,0-13.6-12.364c-2.13-1.074-3.537-1.557-3.505-1.646a4.055,4.055,0,0,1,1.013.266,22.524,22.524,0,0,1,2.653,1.048,31.165,31.165,0,0,1,13.758,12.5,22.715,22.715,0,0,1,1.3,2.541A4.041,4.041,0,0,1,355.064,372.317Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19814",
    "data-name": "Group 19814",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51918",
    "data-name": "Path 51918",
    d: "M336.545,354.238a35.153,35.153,0,0,1,10.546,1.909c3.59,1.345,6.908,3.921,8.228,7.52a2.479,2.479,0,0,1-.187,2.6,1.851,1.851,0,0,1-1.895.3,5.014,5.014,0,0,1-1.656-1.139c-2.2-2.039-4.489-3.84-6.765-5.8s-5.582-4.02-8.551-4.474"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19815",
    "data-name": "Group 19815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51919",
    "data-name": "Path 51919",
    d: "M329.336,347.86a4.631,4.631,0,0,1-1.043.6,18.163,18.163,0,0,1-3.076,1.16,20.544,20.544,0,0,1-20.136-5.229,18.23,18.23,0,0,1-2.123-2.511,4.619,4.619,0,0,1-.618-1.034c.084-.063.994,1.4,3,3.279a21.189,21.189,0,0,0,19.787,5.139C327.784,348.6,329.294,347.765,329.336,347.86Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19816",
    "data-name": "Group 19816",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51920",
    "data-name": "Path 51920",
    d: "M302.883,341.621c1.683,3.662,3.661,7.346,6.854,9.8a10.994,10.994,0,0,0,6.316,2.647c3.338.055,6.2-2.222,8.752-4.38-8.251,1.292-17.551-2.451-21.922-8.072"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19817",
    "data-name": "Group 19817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51921",
    "data-name": "Path 51921",
    d: "M339.855,292.616c-.159-.009.033-3.434-.379-7.624-.391-4.193-1.229-7.519-1.075-7.558a8.221,8.221,0,0,1,.694,2.145,38.528,38.528,0,0,1,1.034,10.8A8.248,8.248,0,0,1,339.855,292.616Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19826",
    "data-name": "Group 19826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51922",
    "data-name": "Path 51922",
    d: "M221.237,426.44s-10.869,2.349-20.572.894c-9.1-1.364-29.466.047-29.459,12.037.009,13.372,27.17,10.068,37.768,7.948s21.15-4.04,21.15-4.04Z",
    fill: "#0093ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19819",
    "data-name": "Group 19819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51923",
    "data-name": "Path 51923",
    d: "M196.844,443.571a44.914,44.914,0,0,1-2.118-9.422,44.912,44.912,0,0,1,2.118,9.422Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19820",
    "data-name": "Group 19820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51924",
    "data-name": "Path 51924",
    d: "M200.551,443.747a45.4,45.4,0,0,1-1.319-9.614,45.425,45.425,0,0,1,1.319,9.614Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19821",
    "data-name": "Group 19821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51925",
    "data-name": "Path 51925",
    d: "M204.131,442.349a34.437,34.437,0,0,1-1.014-8.4,34.453,34.453,0,0,1,1.014,8.4Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19822",
    "data-name": "Group 19822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51926",
    "data-name": "Path 51926",
    d: "M209.753,440.947a14.368,14.368,0,0,1-1.8-7.4,1088.283,1088.283,0,0,1,1.8,7.4Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19823",
    "data-name": "Group 19823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51927",
    "data-name": "Path 51927",
    d: "M210.958,436.059a4.673,4.673,0,0,1,1.42-.1,12.049,12.049,0,0,1,3.816.747,4.247,4.247,0,0,1,1.175.633,1.784,1.784,0,0,1,.736,1.325,2.01,2.01,0,0,1-2.461,1.788,5.062,5.062,0,0,1-2.837-2.02,8.629,8.629,0,0,1-1.605-3.343,8.49,8.49,0,0,1,1.2-6.924,1.38,1.38,0,0,1,.807-.486,1.1,1.1,0,0,1,.9.282,2.431,2.431,0,0,1,.68,1.459,7.42,7.42,0,0,1-.143,2.72,7.554,7.554,0,0,1-1.834,3.429,5.92,5.92,0,0,1-.793.7c-.2.139-.307.2-.318.19-.03-.037.379-.341.959-1.028a7.81,7.81,0,0,0,1.626-3.376,7.182,7.182,0,0,0,.076-2.575,2.027,2.027,0,0,0-.555-1.178.7.7,0,0,0-1.049.175,8.481,8.481,0,0,0,.451,9.637,4.647,4.647,0,0,0,2.52,1.862,1.571,1.571,0,0,0,1.944-1.306,1.378,1.378,0,0,0-.559-1.025,3.939,3.939,0,0,0-1.053-.6,13.24,13.24,0,0,0-3.7-.887C211.465,436.084,210.959,436.1,210.958,436.059Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19824",
    "data-name": "Group 19824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51928",
    "data-name": "Path 51928",
    d: "M229.049,441.51a1.175,1.175,0,0,1-.274.087l-.815.2-3.151.718c-2.742.6-6.718,1.449-11.658,2.4s-10.843,2.031-17.459,2.932a47.149,47.149,0,0,1-10.49.523,22.539,22.539,0,0,1-5.494-1.05,15.087,15.087,0,0,1-2.637-1.172,8.142,8.142,0,0,1-2.316-1.865l.04.044a5.515,5.515,0,0,1-.945-1.134,7.072,7.072,0,0,1-.553-5.852,9.355,9.355,0,0,1,3.484-4.555,17.709,17.709,0,0,1,4.953-2.454c.867-.246,1.711-.543,2.57-.738.863-.172,1.706-.4,2.557-.519,6.812-1.075,13.008-.529,18.155-.527,2.581.048,4.912-.022,6.955-.147a46.549,46.549,0,0,0,5.2-.658l1.874-.394,1.35-.385.834-.229a1.327,1.327,0,0,1,.29-.062,1.205,1.205,0,0,1-.273.112l-.82.279-1.342.435-1.873.442a43.486,43.486,0,0,1-5.222.75c-2.051.154-4.394.25-6.979.226-5.159.043-11.351-.459-18.073.632-.841.119-1.67.349-2.521.52-.846.195-1.674.491-2.526.734a17.241,17.241,0,0,0-4.809,2.394,8.857,8.857,0,0,0-3.3,4.3,6.571,6.571,0,0,0,.5,5.416,5.02,5.02,0,0,0,.852,1.023l.017.017.023.029a7.8,7.8,0,0,0,2.148,1.713,14.643,14.643,0,0,0,2.542,1.132,22.153,22.153,0,0,0,5.372,1.034,47.09,47.09,0,0,0,10.386-.489c6.6-.872,12.507-1.918,17.454-2.817s8.931-1.7,11.684-2.242l3.17-.623.826-.153A1.263,1.263,0,0,1,229.049,441.51Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19825",
    "data-name": "Group 19825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51929",
    "data-name": "Path 51929",
    d: "M189.306,447.949a17.979,17.979,0,0,1-.263-2.777c-.123-1.715-.327-4.078-.674-6.674s-.774-4.931-1.106-6.617a17.838,17.838,0,0,1-.477-2.749,12.668,12.668,0,0,1,.836,2.668,61.246,61.246,0,0,1,1.789,13.355A12.64,12.64,0,0,1,189.306,447.949Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_51930",
    "data-name": "Path 51930",
    d: "M217.892,427.019l6.887,17.25,5.345-.99L219.888,426.44Z",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_51931",
    "data-name": "Path 51931",
    d: "M307.651,379.736c-1.108.369-72.282-19.576-101.065-27.669a27.34,27.34,0,0,0-22.259,3.369l-.347.224a27.345,27.345,0,0,0-11.774,29.152h0a27.331,27.331,0,0,0,12.343,17.115c18.981,11.628,59.15,36.092,60.379,35.616,1.609-.624,51.775-1.925,51.775-1.925l-60.351-43.4,28.711,18.556,42.588-31.034Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51932",
    "data-name": "Path 51932",
    d: "M248.229,358.077l15.13-7.827,14.836,9.3,55.549,1.815,8.04,27.043-80.4-18.638s-14.634,1.3-15.73-1.994S248.229,358.077,248.229,358.077Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51933",
    "data-name": "Path 51933",
    d: "M293.738,401.415l-7.478,24.557.93,7.484h0a38.424,38.424,0,0,0,50.68,3.416h0a37.654,37.654,0,0,0,14.723-30.033l-.112-25.659Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19827",
    "data-name": "Group 19827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51934",
    "data-name": "Path 51934",
    d: "M249.2,401.575c-.086.116-8.767-6.213-19.387-14.134S210.653,373,210.739,372.887s8.766,6.212,19.389,14.136S249.29,401.46,249.2,401.575Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19828",
    "data-name": "Group 19828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51935",
    "data-name": "Path 51935",
    d: "M262.339,355.153a59.509,59.509,0,0,1-7.4,2.645,59.5,59.5,0,0,1-7.559,2.148,59.334,59.334,0,0,1,7.4-2.644A59.353,59.353,0,0,1,262.339,355.153Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19829",
    "data-name": "Group 19829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51936",
    "data-name": "Path 51936",
    d: "M263.47,359.764a15.823,15.823,0,0,1-2.577.484c-1.593.26-3.787.651-6.184,1.2s-4.542,1.158-6.089,1.621a15.677,15.677,0,0,1-2.529.689,11.3,11.3,0,0,1,2.414-1.039,54.368,54.368,0,0,1,12.339-2.837A11.309,11.309,0,0,1,263.47,359.764Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19830",
    "data-name": "Group 19830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51937",
    "data-name": "Path 51937",
    d: "M262.2,363.995a70.375,70.375,0,0,1-8.335,1.918,70.013,70.013,0,0,1-8.438,1.407,70.835,70.835,0,0,1,8.336-1.918A70.432,70.432,0,0,1,262.2,363.995Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19831",
    "data-name": "Group 19831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51938",
    "data-name": "Path 51938",
    d: "M242.575,321.8l13.956,45.921a1.332,1.332,0,0,0,1.173.94l38.031,2.854a1.329,1.329,0,0,1,1.23,1.326v2.374a1.33,1.33,0,0,1-1.355,1.33L191.649,374.59a1.333,1.333,0,0,1-1.218-.856l-18.282-47.9a1.329,1.329,0,0,1,1.18-1.8l67.911-3.177A1.329,1.329,0,0,1,242.575,321.8Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51939",
    "data-name": "Path 51939",
    d: "M213.28,341.584a3.28,3.28,0,0,0-2.057,2.336,3.147,3.147,0,0,0,1.344,2.861,3.419,3.419,0,0,0,3.8.142,3.168,3.168,0,0,0,1.037-3.838c-.459-1.268-2.78-2.155-4.124-1.5",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19844",
    "data-name": "Group 19844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51940",
    "data-name": "Path 51940",
    d: "M230.124,443.279,219.136,425.2l80.8-63.327a32.466,32.466,0,0,1,17.648-7.233h0a32.469,32.469,0,0,1,35.3,35.038L351.6,405.13l-53.634,17.235Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19832",
    "data-name": "Group 19832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51941",
    "data-name": "Path 51941",
    d: "M333.744,400.359a1.216,1.216,0,0,1-.214.2l-.66.544-2.573,2.054-1.869,1.475c-.682.541-1.485,1.042-2.315,1.628l-2.684,1.84c-.477.323-.96.667-1.471,1l-1.6.966c-2.2,1.31-4.565,2.812-7.252,4.169-1.332.7-2.691,1.457-4.127,2.167l-4.465,2.116c-6.151,2.8-13.041,5.625-20.427,8.136-14.759,5.086-28.4,8.747-38.176,11.71-2.451.721-4.659,1.4-6.593,2.007s-3.608,1.115-4.959,1.575l-3.128,1.016-.818.252a1.2,1.2,0,0,1-.285.069,1.213,1.213,0,0,1,.267-.119l.8-.3,3.1-1.11c1.343-.489,3-1.034,4.935-1.659s4.13-1.339,6.574-2.082c9.752-3.055,23.38-6.772,38.113-11.85,7.374-2.507,14.251-5.307,20.4-8.08l4.462-2.091c1.436-.7,2.794-1.451,4.127-2.137,2.688-1.337,5.061-2.815,7.263-4.1l1.609-.948c.512-.323,1-.662,1.477-.978l2.7-1.8c.836-.573,1.646-1.062,2.335-1.59l1.892-1.435c1.118-.84,2-1.5,2.63-1.974l.692-.5A1.234,1.234,0,0,1,333.744,400.359Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19833",
    "data-name": "Group 19833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51942",
    "data-name": "Path 51942",
    d: "M335.7,408.811a3.125,3.125,0,0,1-.815.427c-.537.246-1.328.568-2.318.936a59.076,59.076,0,0,1-16.091,3.458c-1.053.071-1.907.1-2.5.1a3.149,3.149,0,0,1-.918-.054,30.686,30.686,0,0,1,3.382-.411c2.087-.233,4.961-.638,8.092-1.308s5.914-1.486,7.913-2.131A30.851,30.851,0,0,1,335.7,408.811Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19834",
    "data-name": "Group 19834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51943",
    "data-name": "Path 51943",
    d: "M296.7,364.913c.088.113-17.206,13.7-38.622,30.348s-38.857,30.054-38.946,29.941,17.2-13.7,38.626-30.352S296.616,364.8,296.7,364.913Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19843",
    "data-name": "Group 19843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19836",
    "data-name": "Group 19836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51944",
    "data-name": "Path 51944",
    d: "M292.034,432.113c-3.876-2.067-8.227-.845-11.935.4-2.469.832-5.034,2.15-7.541,1.444-1.813-.511-3.161-1.98-4.546-3.257a28.573,28.573,0,0,0-20.886-7.483,8.506,8.506,0,0,0-5.736,2.593c-3.807,4.123-.936,9.489,2.466,12.956a37.589,37.589,0,0,0,22.713,10.957c7.089.74,16.837-.239,24.027-3.317,4.432-1.9,6.707-7.127,4.381-11.35A7.283,7.283,0,0,0,292.034,432.113Z",
    fill: "#0093ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19835",
    "data-name": "Group 19835",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51945",
    "data-name": "Path 51945",
    d: "M292.026,435.413c-3.876-2.067-8.227-.845-11.936.4-2.468.832-5.033,2.15-7.54,1.444-1.813-.511-3.162-1.98-4.546-3.257a28.576,28.576,0,0,0-20.887-7.484,8.509,8.509,0,0,0-5.736,2.594,6.615,6.615,0,0,0-1.6,2.89,15.076,15.076,0,0,0,4.064,6.766,37.591,37.591,0,0,0,22.714,10.957c7.089.74,16.837-.239,24.026-3.317a8.768,8.768,0,0,0,5.114-6.1,7.4,7.4,0,0,0-.733-1.955A7.281,7.281,0,0,0,292.026,435.413Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19837",
    "data-name": "Group 19837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51946",
    "data-name": "Path 51946",
    d: "M295.7,440.316a6.731,6.731,0,0,0-.95-2.3,7.517,7.517,0,0,0-2.074-2.028,8.285,8.285,0,0,0-3.563-1.364c-2.878-.338-6.212.873-9.916,1.876-1.831.484-3.831,1.226-6.02.951a7.98,7.98,0,0,1-3.1-1.072,19.252,19.252,0,0,1-2.662-2,28.978,28.978,0,0,0-15.873-7.523,16.594,16.594,0,0,0-4.691-.027,10.221,10.221,0,0,0-3.629,1.266A9.254,9.254,0,0,0,241,429.979a22.5,22.5,0,0,0-1.431,2.066,8.043,8.043,0,0,1,1.275-2.2,9.081,9.081,0,0,1,2.227-2,10.369,10.369,0,0,1,3.721-1.382,16.709,16.709,0,0,1,4.8-.037,27.62,27.62,0,0,1,5.373,1.2,31.1,31.1,0,0,1,5.564,2.456,23.182,23.182,0,0,1,2.708,1.763c.862.676,1.679,1.418,2.516,2.14a19.082,19.082,0,0,0,2.586,1.954,7.487,7.487,0,0,0,2.9,1.011c2.028.268,3.973-.425,5.83-.908,3.687-.966,7.079-2.173,10.088-1.778a8.337,8.337,0,0,1,5.761,3.647,5.381,5.381,0,0,1,.717,1.75A2.462,2.462,0,0,1,295.7,440.316Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19838",
    "data-name": "Group 19838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51947",
    "data-name": "Path 51947",
    d: "M295.7,440.316a6.731,6.731,0,0,0-.95-2.3,7.517,7.517,0,0,0-2.074-2.028,8.285,8.285,0,0,0-3.563-1.364c-2.878-.338-6.212.873-9.916,1.876-1.831.484-3.831,1.226-6.02.951a7.98,7.98,0,0,1-3.1-1.072,19.252,19.252,0,0,1-2.662-2,28.978,28.978,0,0,0-15.873-7.523,16.594,16.594,0,0,0-4.691-.027,10.221,10.221,0,0,0-3.629,1.266A9.254,9.254,0,0,0,241,429.979a22.5,22.5,0,0,0-1.431,2.066,8.043,8.043,0,0,1,1.275-2.2,9.081,9.081,0,0,1,2.227-2,10.369,10.369,0,0,1,3.721-1.382,16.709,16.709,0,0,1,4.8-.037,27.62,27.62,0,0,1,5.373,1.2,31.1,31.1,0,0,1,5.564,2.456,23.182,23.182,0,0,1,2.708,1.763c.862.676,1.679,1.418,2.516,2.14a19.082,19.082,0,0,0,2.586,1.954,7.487,7.487,0,0,0,2.9,1.011c2.028.268,3.973-.425,5.83-.908,3.687-.966,7.079-2.173,10.088-1.778a8.337,8.337,0,0,1,5.761,3.647,5.381,5.381,0,0,1,.717,1.75A2.462,2.462,0,0,1,295.7,440.316Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19839",
    "data-name": "Group 19839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51948",
    "data-name": "Path 51948",
    d: "M247.631,439.383a9.947,9.947,0,0,1,1.985-1.375,57.264,57.264,0,0,1,10.523-4.947,9.938,9.938,0,0,1,2.324-.651,12.577,12.577,0,0,1-2.193,1c-1.369.57-3.252,1.372-5.3,2.332s-3.862,1.9-5.175,2.591A12.515,12.515,0,0,1,247.631,439.383Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19840",
    "data-name": "Group 19840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51949",
    "data-name": "Path 51949",
    d: "M248.963,443.26a69.967,69.967,0,0,1,7.569-3.949,69.97,69.97,0,0,1,7.8-3.48,70.438,70.438,0,0,1-7.571,3.949A70.4,70.4,0,0,1,248.963,443.26Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19841",
    "data-name": "Group 19841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51950",
    "data-name": "Path 51950",
    d: "M265.02,444.941c-.077.121-4.207-2.343-9.224-5.5s-9.024-5.823-8.947-5.944,4.206,2.342,9.225,5.5S265.1,444.819,265.02,444.941Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19842",
    "data-name": "Group 19842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51951",
    "data-name": "Path 51951",
    d: "M267.344,440.919a12.346,12.346,0,0,1-2.022-1.351c-1.215-.876-2.891-2.087-4.767-3.388s-3.6-2.445-4.845-3.276a12.284,12.284,0,0,1-1.975-1.419,10.424,10.424,0,0,1,2.169,1.107c1.3.753,3.062,1.854,4.948,3.16s3.533,2.57,4.694,3.524A10.432,10.432,0,0,1,267.344,440.919Z",
    fill: "#263238"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_19503",
    "data-name": "Group 19503",
    transform: "translate(1353.145 299.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19490",
    "data-name": "Group 19490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19489",
    "data-name": "Group 19489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51746",
    "data-name": "Path 51746",
    d: "M464.461,413.446s-.012-.375-.018-1.089-.01-1.776-.018-3.156c-.01-2.772-.024-6.839-.041-12.06-.021-10.436-.051-25.477-.088-43.944l.165.164-104.129.049h-.008l.213-.213c0,21.323-.01,41.7-.015,60.249l-.2-.2,74.9.1,21.51.054,5.735.024,1.483.012c.334,0,.511.012.511.012s-.161.008-.487.012l-1.461.012-5.7.024-21.464.054-75.03.1h-.2v-.2c0-18.552-.01-38.926-.015-60.249v-.213h.221l104.129.049h.164v.164c-.037,18.509-.067,33.585-.087,44.046-.018,5.2-.032,9.259-.042,12.023-.008,1.366-.014,2.411-.018,3.125S464.461,413.446,464.461,413.446Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19492",
    "data-name": "Group 19492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19491",
    "data-name": "Group 19491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51747",
    "data-name": "Path 51747",
    d: "M464.5,360.492c0,.118-23.293.213-52.019.213s-52.024-.1-52.024-.213,23.288-.213,52.024-.213S464.5,360.374,464.5,360.492Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19493",
    "data-name": "Group 19493"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19496",
    "data-name": "Rectangle 19496",
    width: 32.167,
    height: 32.167,
    transform: "translate(369.344 370.426)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19502",
    "data-name": "Group 19502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19495",
    "data-name": "Group 19495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19494",
    "data-name": "Group 19494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51748",
    "data-name": "Path 51748",
    d: "M456.909,375.732a1.981,1.981,0,0,1-.473.043l-1.357.04-4.989.068-16.461.062-16.463-.062-4.989-.068-1.356-.04a1.981,1.981,0,0,1-.473-.043,1.983,1.983,0,0,1,.473-.043l1.356-.04,4.989-.067,16.463-.063,16.461.063,4.989.067,1.357.04A1.983,1.983,0,0,1,456.909,375.732Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19497",
    "data-name": "Group 19497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19496",
    "data-name": "Group 19496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51749",
    "data-name": "Path 51749",
    d: "M457.945,382.917a2.072,2.072,0,0,1-.484.043l-1.386.04-5.1.068-16.826.062-16.83-.062-5.1-.068-1.387-.04a2.057,2.057,0,0,1-.483-.043,2.134,2.134,0,0,1,.483-.043l1.387-.039,5.1-.068,16.83-.063,16.826.063,5.1.068,1.386.039A2.15,2.15,0,0,1,457.945,382.917Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19499",
    "data-name": "Group 19499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19498",
    "data-name": "Group 19498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51750",
    "data-name": "Path 51750",
    d: "M457.945,390.1a2.148,2.148,0,0,1-.484.043l-1.386.04-5.1.067-16.826.063-16.83-.063-5.1-.067-1.387-.04a2.132,2.132,0,0,1-.483-.043,2.062,2.062,0,0,1,.483-.043l1.387-.04,5.1-.068,16.83-.062,16.826.062,5.1.068,1.386.04A2.077,2.077,0,0,1,457.945,390.1Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19501",
    "data-name": "Group 19501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19500",
    "data-name": "Group 19500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51751",
    "data-name": "Path 51751",
    d: "M457.945,397.288a2.148,2.148,0,0,1-.484.043l-1.386.04-5.1.067-16.826.063-16.83-.063-5.1-.067-1.387-.04a2.132,2.132,0,0,1-.483-.043,2.062,2.062,0,0,1,.483-.043l1.387-.04,5.1-.068,16.83-.062,16.826.062,5.1.068,1.386.04A2.077,2.077,0,0,1,457.945,397.288Z",
    fill: "#e0e0e0"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rocket",
    transform: "translate(1197.016 219.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51786",
    "data-name": "Path 51786",
    d: "M304.686,114.736c-4-2.668-9.5-1.054-13.5,1.616s-7.422,6.328-11.908,8.07c-8.421,3.273-19.459-.605-26.006,5.624-4.153,3.954-4.577,10.443-7.751,15.218-5.347,8.044-18.175,11.066-19.275,20.662-.642,5.6,3.786,10.965,9.2,12.535s11.363-.087,16.055-3.207c5.48-3.642,9.784-9.258,16.03-11.332,6.382-2.118,14.258-.345,19.293-4.8s4.282-12.651,7.893-18.339c1.921-3.028,4.952-5.14,7.666-7.483s5.3-5.244,5.753-8.8-1-9.625-3.448-9.762",
    transform: "translate(27.364 29.431)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19625",
    "data-name": "Group 19625",
    transform: "translate(193.802 141.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19581",
    "data-name": "Group 19581",
    transform: "translate(34.22 394.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51787",
    "data-name": "Path 51787",
    d: "M212.414,326.567c.227-.137.974.609,1.67,1.666s1.085,2.041.869,2.2-.965-.594-1.672-1.668S212.187,326.706,212.414,326.567Z",
    transform: "translate(-212.349 -326.551)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19582",
    "data-name": "Group 19582",
    transform: "translate(26.319 378.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51788",
    "data-name": "Path 51788",
    d: "M208.125,317.541c.251-.085,1.234,1.745,2.2,4.087s1.546,4.338,1.308,4.454-1.221-1.714-2.2-4.089S207.874,317.626,208.125,317.541Z",
    transform: "translate(-208.067 -317.538)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19583",
    "data-name": "Group 19583",
    transform: "translate(21.973 360.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51789",
    "data-name": "Path 51789",
    d: "M205.836,307.818c.264-.033.852,1.959,1.315,4.45s.627,4.565.369,4.627-.847-1.928-1.314-4.45S205.574,307.851,205.836,307.818Z",
    transform: "translate(-205.711 -307.818)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19584",
    "data-name": "Group 19584",
    transform: "translate(20.902 341.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51790",
    "data-name": "Path 51790",
    d: "M205.679,297.83c.264.018.452,2.089.415,4.622s-.279,4.6-.544,4.609-.452-2.057-.415-4.624S205.416,297.81,205.679,297.83Z",
    transform: "translate(-205.131 -297.83)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19585",
    "data-name": "Group 19585",
    transform: "translate(22.376 323.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51791",
    "data-name": "Path 51791",
    d: "M207.987,287.967c.255.07.03,2.137-.5,4.614s-1.183,4.452-1.445,4.411-.037-2.107.506-4.614S207.731,287.895,207.987,287.967Z",
    transform: "translate(-205.93 -287.965)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19586",
    "data-name": "Group 19586",
    transform: "translate(27.239 306.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51792",
    "data-name": "Path 51792",
    d: "M212.395,278.65c.234.124-.413,2.1-1.45,4.408s-2.077,4.107-2.327,4.015.4-2.066,1.45-4.408S212.161,278.524,212.395,278.65Z",
    transform: "translate(-208.565 -278.644)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19587",
    "data-name": "Group 19587",
    transform: "translate(35.712 290.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51793",
    "data-name": "Path 51793",
    d: "M218.681,270.319c.2.168-.854,1.956-2.365,3.991s-2.928,3.559-3.122,3.432c-.249-.164.825-1.941,2.349-4S218.476,270.151,218.681,270.319Z",
    transform: "translate(-213.158 -270.306)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19588",
    "data-name": "Group 19588",
    transform: "translate(47.251 277.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51794",
    "data-name": "Path 51794",
    d: "M225.8,262.913c.188.186-1.081,1.832-2.836,3.673s-3.336,3.19-3.531,3.011,1.072-1.823,2.834-3.673S225.609,262.727,225.8,262.913Z",
    transform: "translate(-219.412 -262.896)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19589",
    "data-name": "Group 19589",
    transform: "translate(60.13 264.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51795",
    "data-name": "Path 51795",
    d: "M232.89,255.8c.192.184-1.105,1.806-2.9,3.624s-3.4,3.138-3.583,2.952,1.109-1.812,2.9-3.625S232.7,255.617,232.89,255.8Z",
    transform: "translate(-226.392 -255.785)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19590",
    "data-name": "Group 19590",
    transform: "translate(72.877 250.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51796",
    "data-name": "Path 51796",
    d: "M239.179,248.259c.212.159-.932,1.893-2.555,3.871s-3.1,3.443-3.3,3.266.947-1.91,2.557-3.873S238.967,248.1,239.179,248.259Z",
    transform: "translate(-233.301 -248.248)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19591",
    "data-name": "Group 19591",
    transform: "translate(83.905 234.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51797",
    "data-name": "Path 51797",
    d: "M243.545,239.672c.242.1-.365,2.109-1.55,4.393s-2.458,3.947-2.681,3.808.666-2,1.827-4.251S243.3,239.569,243.545,239.672Z",
    transform: "translate(-239.279 -239.668)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19592",
    "data-name": "Group 19592",
    transform: "translate(91.053 216.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51798",
    "data-name": "Path 51798",
    d: "M244.762,230.006c.26.018.325,2.118-.1,4.659s-1.162,4.509-1.415,4.441.057-2.105.467-4.6S244.493,229.988,244.762,230.006Z",
    transform: "translate(-243.153 -230.006)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19593",
    "data-name": "Group 19593",
    transform: "translate(91.194 198.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51799",
    "data-name": "Path 51799",
    d: "M243.329,220.068c.251-.065.974,1.91,1.365,4.454s.31,4.646.052,4.661-.611-2.017-1-4.513S243.067,220.134,243.329,220.068Z",
    transform: "translate(-243.229 -220.066)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19594",
    "data-name": "Group 19594",
    transform: "translate(84.011 181.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51800",
    "data-name": "Path 51800",
    d: "M239.368,210.924c.214-.149,1.572,1.459,2.786,3.731s1.814,4.286,1.572,4.384-1.225-1.708-2.419-3.93S239.144,211.076,239.368,210.924Z",
    transform: "translate(-239.336 -210.915)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19595",
    "data-name": "Group 19595",
    transform: "translate(71.16 168.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51801",
    "data-name": "Path 51801",
    d: "M232.381,203.837c.142-.218,2.007.762,3.985,2.421s3.277,3.316,3.089,3.495-1.766-1.144-3.7-2.758S232.229,204.062,232.381,203.837Z",
    transform: "translate(-232.371 -203.807)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19596",
    "data-name": "Group 19596",
    transform: "translate(54.397 160.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51802",
    "data-name": "Path 51802",
    d: "M223.287,199.807c.055-.255,2.146,0,4.587.836s4.251,1.91,4.14,2.146-2.063-.423-4.452-1.236S223.226,200.069,223.287,199.807Z",
    transform: "translate(-223.285 -199.713)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19597",
    "data-name": "Group 19597",
    transform: "translate(36.066 158.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51803",
    "data-name": "Path 51803",
    d: "M213.35,199.766c-.046-.255,1.985-.828,4.566-.959s4.659.212,4.64.47-2.074.354-4.59.489S213.4,200.033,213.35,199.766Z",
    transform: "translate(-213.35 -198.775)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19598",
    "data-name": "Group 19598",
    transform: "translate(19.036 162.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51804",
    "data-name": "Path 51804",
    d: "M204.13,205.01c-.151-.21,1.432-1.607,3.712-2.828s4.321-1.771,4.41-1.53-1.738,1.179-3.954,2.376S204.286,205.231,204.13,205.01Z",
    transform: "translate(-204.12 -200.596)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19599",
    "data-name": "Group 19599",
    transform: "translate(6.345 172.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51805",
    "data-name": "Path 51805",
    d: "M197.274,213.519c-.223-.131.675-2.041,2.264-4.078s3.208-3.386,3.391-3.2-1.09,1.8-2.633,3.792S197.505,213.659,197.274,213.519Z",
    transform: "translate(-197.241 -206.222)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19600",
    "data-name": "Group 19600",
    transform: "translate(0 188.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51806",
    "data-name": "Path 51806",
    d: "M193.964,223.626c-.258-.024-.256-2.14.358-4.655s1.565-4.4,1.8-4.3-.28,2.083-.871,4.531S194.234,223.654,193.964,223.626Z",
    transform: "translate(-193.802 -214.663)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19601",
    "data-name": "Group 19601",
    transform: "translate(0.019 206.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51807",
    "data-name": "Path 51807",
    d: "M196.146,233.467c-.242.094-1.194-1.788-1.8-4.3s-.629-4.625-.371-4.651.7,1.98,1.3,4.424S196.4,233.371,196.146,233.467Z",
    transform: "translate(-193.812 -224.513)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19602",
    "data-name": "Group 19602",
    transform: "translate(6.297 223.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51808",
    "data-name": "Path 51808",
    d: "M202.627,241.371c-.2.17-1.725-1.268-3.229-3.36s-2.375-4.006-2.148-4.135,1.448,1.526,2.928,3.574S202.832,241.194,202.627,241.371Z",
    transform: "translate(-197.215 -233.869)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19603",
    "data-name": "Group 19603",
    transform: "translate(18.101 237.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51809",
    "data-name": "Path 51809",
    d: "M210.807,247.344c-.151.214-1.978-.81-3.976-2.424s-3.382-3.186-3.2-3.378,1.834,1.042,3.808,2.631S210.962,247.124,210.807,247.344Z",
    transform: "translate(-203.613 -241.521)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19604",
    "data-name": "Group 19604",
    transform: "translate(33.052 248.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51810",
    "data-name": "Path 51810",
    d: "M219.952,251.582c-.105.244-2.046-.5-4.332-1.662s-4.031-2.292-3.9-2.52,2.074.515,4.332,1.662S220.057,251.34,219.952,251.582Z",
    transform: "translate(-211.716 -247.358)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19605",
    "data-name": "Group 19605",
    transform: "translate(49.904 255.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51811",
    "data-name": "Path 51811",
    d: "M229.791,253.759c-.046.258-2.135.1-4.624-.544s-4.4-1.5-4.315-1.745,2.1.186,4.555.814S229.839,253.495,229.791,253.759Z",
    transform: "translate(-220.85 -251.395)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19606",
    "data-name": "Group 19606",
    transform: "translate(68.002 259.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51812",
    "data-name": "Path 51812",
    d: "M239.879,253.3c.029.258-2.024.7-4.6.745s-4.64-.3-4.622-.563,2.077-.347,4.6-.4S239.849,253.03,239.879,253.3Z",
    transform: "translate(-230.659 -253.06)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19607",
    "data-name": "Group 19607",
    transform: "translate(86.299 254.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51813",
    "data-name": "Path 51813",
    d: "M249.257,250.639c.113.234-1.686,1.321-4.113,2.192s-4.5,1.179-4.566.926,1.867-.972,4.242-1.832S249.142,250.394,249.257,250.639Z",
    transform: "translate(-240.576 -250.589)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19608",
    "data-name": "Group 19608",
    transform: "translate(103.043 244.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51814",
    "data-name": "Path 51814",
    d: "M256.979,245.164c.177.192-1.223,1.755-3.266,3.319s-3.913,2.515-4.053,2.3,1.465-1.515,3.469-3.057S256.8,244.963,256.979,245.164Z",
    transform: "translate(-249.651 -245.142)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19609",
    "data-name": "Group 19609",
    transform: "translate(116.817 230.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51815",
    "data-name": "Path 51815",
    d: "M262.682,237.592c.221.14-.72,2.013-2.266,4.068s-3.081,3.485-3.277,3.312.991-1.862,2.507-3.887S262.455,237.446,262.682,237.592Z",
    transform: "translate(-257.117 -237.583)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19610",
    "data-name": "Group 19610",
    transform: "translate(126.874 213.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51816",
    "data-name": "Path 51816",
    d: "M266.067,228.6c.249.077-.173,2.131-1.14,4.515s-2.079,4.161-2.312,4.044.476-2.055,1.423-4.4S265.81,228.513,266.067,228.6Z",
    transform: "translate(-262.567 -228.594)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19611",
    "data-name": "Group 19611",
    transform: "translate(132.573 195.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51817",
    "data-name": "Path 51817",
    d: "M267.028,218.8c.262.018.33,2.111-.018,4.653s-.978,4.542-1.234,4.489-.059-2.109.282-4.618S266.761,218.78,267.028,218.8Z",
    transform: "translate(-265.656 -218.798)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19612",
    "data-name": "Group 19612",
    transform: "translate(133.23 177.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51818",
    "data-name": "Path 51818",
    d: "M266.253,208.808c.262-.035.637,2.009.834,4.566s.144,4.633-.122,4.638-.64-2.039-.836-4.566S265.989,208.845,266.253,208.808Z",
    transform: "translate(-266.013 -208.808)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19613",
    "data-name": "Group 19613",
    transform: "translate(129.379 159.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51819",
    "data-name": "Path 51819",
    d: "M264.01,199.049c.253-.083,1,1.856,1.67,4.332s1,4.528.743,4.583-1.007-1.884-1.67-4.332S263.757,199.13,264.01,199.049Z",
    transform: "translate(-263.925 -199.047)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19614",
    "data-name": "Group 19614",
    transform: "translate(122.355 142.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51820",
    "data-name": "Path 51820",
    d: "M260.164,189.81c.231-.12,1.347,1.64,2.456,3.948,1.035,2.345,1.675,4.327,1.43,4.426s-1.277-1.7-2.3-4.02C260.649,191.876,259.924,189.933,260.164,189.81Z",
    transform: "translate(-260.118 -189.804)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19615",
    "data-name": "Group 19615",
    transform: "translate(113.286 126.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51821",
    "data-name": "Path 51821",
    d: "M255.24,181.1c.227-.137,1.458,1.539,2.749,3.74s2.151,4.092,1.921,4.223-1.463-1.542-2.751-3.74S255.011,181.235,255.24,181.1Z",
    transform: "translate(-255.203 -181.091)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19616",
    "data-name": "Group 19616",
    transform: "translate(104.122 110.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51822",
    "data-name": "Path 51822",
    d: "M250.277,172.411c.236-.122,1.424,1.583,2.655,3.806s2.044,4.137,1.814,4.271-1.417-1.57-2.655-3.808S250.041,172.533,250.277,172.411Z",
    transform: "translate(-250.236 -172.405)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19617",
    "data-name": "Group 19617",
    transform: "translate(96.891 93.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51823",
    "data-name": "Path 51823",
    d: "M246.382,163.214c.255-.077,1.177,1.782,2.059,4.153s1.4,4.38,1.159,4.487-1.164-1.753-2.059-4.155S246.127,163.29,246.382,163.214Z",
    transform: "translate(-246.317 -163.212)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19618",
    "data-name": "Group 19618",
    transform: "translate(93.534 75.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51824",
    "data-name": "Path 51824",
    d: "M244.779,153.378c.269-.007.55,2.037.819,4.552s.423,4.574.159,4.622-.845-1.963-1.114-4.52S244.519,153.385,244.779,153.378Z",
    transform: "translate(-244.497 -153.378)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19619",
    "data-name": "Group 19619",
    transform: "translate(93.793 56.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51825",
    "data-name": "Path 51825",
    d: "M246.184,143.429c.264.057.031,2.111-.332,4.614s-.732,4.539-1,4.518-.323-2.113.05-4.657S245.93,143.371,246.184,143.429Z",
    transform: "translate(-244.638 -143.427)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19620",
    "data-name": "Group 19620",
    transform: "translate(97.731 39.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51826",
    "data-name": "Path 51826",
    d: "M250.4,133.995c.24.122-.5,2.05-1.47,4.384s-1.83,4.214-2.087,4.129.207-2.127,1.2-4.5S250.163,133.876,250.4,133.995Z",
    transform: "translate(-246.772 -133.989)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19621",
    "data-name": "Group 19621",
    transform: "translate(105.959 24.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51827",
    "data-name": "Path 51827",
    d: "M256.913,125.72c.2.179-1.018,1.847-2.565,3.847s-2.862,3.6-3.087,3.447.749-2,2.327-4.033S256.72,125.543,256.913,125.72Z",
    transform: "translate(-251.232 -125.705)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19622",
    "data-name": "Group 19622",
    transform: "translate(118.166 11.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51828",
    "data-name": "Path 51828",
    d: "M265.171,119.146c.148.223-1.446,1.537-3.448,3.085s-3.681,2.751-3.86,2.552,1.236-1.745,3.273-3.314S265.027,118.927,265.171,119.146Z",
    transform: "translate(-257.848 -119.115)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19623",
    "data-name": "Group 19623",
    transform: "translate(133.435 3.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51829",
    "data-name": "Path 51829",
    d: "M274.6,114.635c.089.253-1.78,1.131-4.1,2.137s-4.245,1.762-4.369,1.524,1.625-1.387,3.987-2.406S274.515,114.388,274.6,114.635Z",
    transform: "translate(-266.124 -114.571)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19624",
    "data-name": "Group 19624",
    transform: "translate(150.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51830",
    "data-name": "Path 51830",
    d: "M280.05,112.87c.039.262-.939.661-2.181.891s-2.3.2-2.358-.055.919-.657,2.183-.891S280.013,112.607,280.05,112.87Z",
    transform: "translate(-275.509 -112.655)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19630",
    "data-name": "Group 19630",
    transform: "translate(294.564 78.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51831",
    "data-name": "Path 51831",
    d: "M298.377,87.372s21.672-15.458,51.661-5.474c0,0,2.465,24.827-21.585,44.57",
    transform: "translate(-206.196 -78.54)",
    fill: "#097bed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51832",
    "data-name": "Path 51832",
    d: "M261.351,131.123c.923,1.384,24.439,39.192,24.439,39.192l70.616-43.5a24.715,24.715,0,0,0,6.9-35.753h0a24.715,24.715,0,0,0-33.638-5.808Z",
    transform: "translate(-237.484 -76.418)",
    fill: "#097bed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51833",
    "data-name": "Path 51833",
    d: "M275.322,138.675l-1.583,26.6s45.762-22.162,34.341-46.782Z",
    transform: "translate(-227.016 -44.778)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51834",
    "data-name": "Path 51834",
    d: "M304.992,98.372s-31.024-13.69-56.577,6.387l23.867,15.577Z",
    transform: "translate(-248.415 -65.632)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51835",
    "data-name": "Path 51835",
    d: "M299.187,108.433l-44.161,27.625s1.517,4.749,2.7,4.354c.994-.332,34.179-19.926,44.939-26.288a3.325,3.325,0,0,0,.869-4.978h0A3.338,3.338,0,0,0,299.187,108.433Z",
    transform: "translate(-242.829 -53.709)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19627",
    "data-name": "Group 19627",
    transform: "translate(80.033 16.788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 14.139,
    cy: 14.139,
    r: 14.139,
    transform: "matrix(0.229, -0.973, 0.973, 0.229, 0, 27.526)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19626",
    "data-name": "Group 19626",
    transform: "translate(2.382 2.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51836",
    "data-name": "Path 51836",
    d: "M321.842,103.511c-.111.007-.052-1.26-.624-3.406a14.1,14.1,0,0,0-5.168-7.561,13.754,13.754,0,0,0-13.013-1.895,13.538,13.538,0,0,0-6.341,4.784,13.626,13.626,0,0,0,0,16.155,13.555,13.555,0,0,0,6.343,4.786,13.759,13.759,0,0,0,13.015-1.895,14.1,14.1,0,0,0,5.166-7.561c.572-2.148.513-3.413.624-3.408a3.2,3.2,0,0,1,.05.908,11.174,11.174,0,0,1-.312,2.59,14.064,14.064,0,0,1-5.116,8.011,14.3,14.3,0,0,1-6.078,2.771,14.535,14.535,0,0,1-7.651-.585,14.363,14.363,0,0,1-6.8-5.059,14.495,14.495,0,0,1,0-17.271,14.346,14.346,0,0,1,6.8-5.059,14.528,14.528,0,0,1,7.649-.585A14.269,14.269,0,0,1,316.462,92a14.069,14.069,0,0,1,5.118,8.011,11.174,11.174,0,0,1,.312,2.59A3.173,3.173,0,0,1,321.842,103.511Z",
    transform: "translate(-293.084 -88.974)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19628",
    "data-name": "Group 19628",
    transform: "translate(102.676 3.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51837",
    "data-name": "Path 51837",
    d: "M329.777,120.2c-.183.018-.4-2.745-1.48-7.042a53.59,53.59,0,0,0-2.458-7.365A53.14,53.14,0,0,0,315.579,89.9a53.985,53.985,0,0,0-5.7-5.273c-3.472-2.755-5.9-4.085-5.81-4.244a7.476,7.476,0,0,1,1.76.832A18.859,18.859,0,0,1,307.8,82.38c.742.491,1.618,1.011,2.5,1.712a47.391,47.391,0,0,1,5.93,5.2,49.839,49.839,0,0,1,10.437,16.164,47.487,47.487,0,0,1,2.3,7.546c.275,1.089.391,2.1.533,2.98a19.222,19.222,0,0,1,.251,2.269A7.529,7.529,0,0,1,329.777,120.2Z",
    transform: "translate(-304.066 -80.378)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19629",
    "data-name": "Group 19629",
    transform: "translate(98.531 4.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51838",
    "data-name": "Path 51838",
    d: "M327.865,121.667c-.183.018-.4-2.792-1.506-7.162a55.082,55.082,0,0,0-2.5-7.5,54.58,54.58,0,0,0-10.389-16.2,55.41,55.41,0,0,0-5.771-5.395c-3.515-2.825-5.974-4.2-5.882-4.356a7.692,7.692,0,0,1,1.782.863,19.47,19.47,0,0,1,1.991,1.2c.751.506,1.637,1.042,2.526,1.76a48.58,48.58,0,0,1,6,5.325,51.164,51.164,0,0,1,10.565,16.472,48.882,48.882,0,0,1,2.336,7.673c.28,1.107.4,2.137.546,3.031a20.058,20.058,0,0,1,.258,2.308A7.834,7.834,0,0,1,327.865,121.667Z",
    transform: "translate(-301.819 -81.049)",
    fill: "#263238"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Gears",
    transform: "translate(1374.145 515.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19670",
    "data-name": "Group 19670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19665",
    "data-name": "Group 19665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19664",
    "data-name": "Group 19664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19663",
    "data-name": "Group 19663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19662",
    "data-name": "Group 19662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51845",
    "data-name": "Path 51845",
    d: "M167.519,316.972a4.789,4.789,0,0,1,1.5.469A6.309,6.309,0,0,1,172,320.463a6.39,6.39,0,0,1,.61,2.919,6.5,6.5,0,0,1-1,3.272,6.487,6.487,0,0,1-2.867,2.463,6.466,6.466,0,0,1-7.514-1.685,6.492,6.492,0,0,1-1.541-3.452,6.5,6.5,0,0,1,.49-3.388,6.4,6.4,0,0,1,1.8-2.379,6.316,6.316,0,0,1,3.99-1.457,4.824,4.824,0,0,1,1.555.216c-.007.045-.554-.11-1.551-.074a6.315,6.315,0,0,0-3.828,1.512,6.186,6.186,0,0,0-2.121,5.527,6.2,6.2,0,0,0,1.476,3.261,6.139,6.139,0,0,0,7.1,1.593,6.193,6.193,0,0,0,2.727-2.318,6.193,6.193,0,0,0,.444-5.9,6.318,6.318,0,0,0-2.816-3C168.067,317.109,167.506,317.016,167.519,316.972Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19669",
    "data-name": "Group 19669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19668",
    "data-name": "Group 19668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19667",
    "data-name": "Group 19667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19666",
    "data-name": "Group 19666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51846",
    "data-name": "Path 51846",
    d: "M172.6,310.191a1.446,1.446,0,0,1-.014-.223c0-.166-.009-.388-.015-.675-.009-.62-.021-1.512-.037-2.671l.045.056-5.771-1.259.1-.05-1.518,3.229-.027.058-.065,0a14.452,14.452,0,0,0-3.762.668l-.069.022-.051-.051-2.538-2.512.161.017-4.981,3.173.058-.169c.372,1.04.783,2.186,1.2,3.361l.03.086-.062.066a14.425,14.425,0,0,0-2.189,3.119l-.043.084h-.1l-3.568.012.158-.126c-.4,1.81-.839,3.763-1.286,5.765l-.092-.19,3.224,1.528.1.044,0,.1a14.4,14.4,0,0,0,.656,3.747l.032.1-.076.076-2.517,2.531.024-.221,3.163,4.988-.213-.073,3.363-1.2.1-.036.081.074a14.291,14.291,0,0,0,3.1,2.188h0c.044.072-.1-.161.1.161v.895l0,.894q0,.894,0,1.78l-.142-.177,5.764,1.294-.2.1,1.532-3.223.047-.1.107,0a14.318,14.318,0,0,0,3.748-.65l.1-.032.076.075,2.528,2.521-.215-.024,4.992-3.156-.068.2q-.608-1.713-1.193-3.365l-.034-.094.068-.072a14.355,14.355,0,0,0,2.2-3.109l.044-.085h.1l3.568,0-.147.118c.459-2.026.893-3.939,1.3-5.761l.076.157-3.22-1.539-.071-.034,0-.079a14.4,14.4,0,0,0-.645-3.763l-.021-.069.051-.051,2.527-2.522-.015.134-3.139-5,.1.033-3.37,1.176-.034.012-.026-.024a15.035,15.035,0,0,0-2.292-1.766l-.614-.37a1.656,1.656,0,0,1-.2-.124,1.529,1.529,0,0,1,.217.1c.141.072.354.182.63.345a14.022,14.022,0,0,1,2.341,1.731l-.06-.012,3.356-1.219.061-.022.035.055,3.183,4.976.046.072-.061.061-2.51,2.538.029-.12a14.59,14.59,0,0,1,.678,3.825l-.075-.113,3.228,1.523.1.048-.024.108c-.4,1.823-.831,3.738-1.282,5.766l-.026.118h-.121l-3.568.014.139-.084a14.669,14.669,0,0,1-2.238,3.186l.034-.165q.589,1.65,1.2,3.361l.045.126-.113.072-4.986,3.166-.116.074-.1-.1-2.532-2.516.177.043a14.676,14.676,0,0,1-3.84.67l.154-.1q-.756,1.6-1.529,3.225l-.061.13-.141-.032-5.764-1.291-.142-.031v-.146l0-1.779,0-.895V336c.2.321.054.089.1.16h0a14.676,14.676,0,0,1-3.184-2.244l.184.038-3.364,1.2-.136.049-.077-.122-3.159-4.991-.076-.121.1-.1,2.521-2.529-.043.177a14.726,14.726,0,0,1-.665-3.839l.1.149-3.222-1.534-.122-.059.03-.131c.451-2,.891-3.952,1.3-5.762l.028-.127h.129l3.569,0-.139.084a14.659,14.659,0,0,1,2.247-3.178l-.031.153c-.416-1.177-.823-2.324-1.191-3.366l-.038-.108.1-.061,5-3.15.088-.055.073.073c.886.886,1.737,1.739,2.523,2.526l-.12-.029a14.6,14.6,0,0,1,3.826-.653l-.092.061,1.543-3.217.032-.067.072.016,5.755,1.326.046.011v.046c-.011,1.148-.019,2.033-.025,2.647-.005.291-.009.516-.012.684A1.77,1.77,0,0,1,172.6,310.191Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19677",
    "data-name": "Group 19677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19673",
    "data-name": "Group 19673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19672",
    "data-name": "Group 19672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19671",
    "data-name": "Group 19671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51847",
    "data-name": "Path 51847",
    d: "M161.718,265.331a16.03,16.03,0,0,1,3.48,2.451l3.718-1.324,3.494,5.516-2.784,2.8a16,16,0,0,1,.73,4.2l3.564,1.692-1.429,6.371-3.945.009a15.956,15.956,0,0,1-2.453,3.48l1.324,3.719-5.515,3.494-2.8-2.784a16,16,0,0,1-4.195.729l-1.692,3.564-6.372-1.429-.008-3.945a15.951,15.951,0,0,1-3.48-2.452l-3.719,1.324-3.5-5.516,2.786-2.8a16.036,16.036,0,0,1-.731-4.194l-3.563-1.692,1.429-6.372,3.945-.009a15.975,15.975,0,0,1,2.452-3.48l-1.324-3.718,5.516-3.495,2.8,2.785a15.994,15.994,0,0,1,4.194-.73l1.692-3.564,6.372,1.429.009,3.946Zm-5.618,7.5a7,7,0,1,0,5.3,8.369A7.005,7.005,0,0,0,156.1,272.828Z",
    transform: "translate(5.22 1.305)",
    fill: "#097bed",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19676",
    "data-name": "Group 19676",
    transform: "translate(-5 -1)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19675",
    "data-name": "Group 19675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19674",
    "data-name": "Group 19674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51848",
    "data-name": "Path 51848",
    d: "M161.718,265.331a16.03,16.03,0,0,1,3.48,2.451l3.718-1.324,3.494,5.516-2.784,2.8a16,16,0,0,1,.73,4.2l3.564,1.692-1.429,6.371-3.945.009a15.956,15.956,0,0,1-2.453,3.48l1.324,3.719-5.515,3.494-2.8-2.784a16,16,0,0,1-4.195.729l-1.692,3.564-6.372-1.429-.008-3.945a15.951,15.951,0,0,1-3.48-2.452l-3.719,1.324-3.5-5.516,2.786-2.8a16.036,16.036,0,0,1-.731-4.194l-3.563-1.692,1.429-6.372,3.945-.009a15.975,15.975,0,0,1,2.452-3.48l-1.324-3.718,5.516-3.495,2.8,2.785a15.994,15.994,0,0,1,4.194-.73l1.692-3.564,6.372,1.429.009,3.946Zm-5.618,7.5a7,7,0,1,0,5.3,8.369A7.005,7.005,0,0,0,156.1,272.828Z",
    transform: "translate(10.22 2.305)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19684",
    "data-name": "Group 19684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19680",
    "data-name": "Group 19680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19679",
    "data-name": "Group 19679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19678",
    "data-name": "Group 19678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51849",
    "data-name": "Path 51849",
    d: "M138.678,302.865a9.348,9.348,0,0,1,2.026,1.427l2.164-.77,2.034,3.211-1.621,1.628a9.319,9.319,0,0,1,.426,2.441l2.074.986-.832,3.709-2.3.005a9.29,9.29,0,0,1-1.427,2.026l.771,2.164-3.211,2.035-1.628-1.621a9.332,9.332,0,0,1-2.442.425l-.985,2.074-3.71-.832,0-2.3a9.294,9.294,0,0,1-2.026-1.428l-2.165.771-2.034-3.211,1.621-1.628a9.324,9.324,0,0,1-.425-2.442l-2.074-.985.831-3.709,2.3-.005a9.29,9.29,0,0,1,1.427-2.026l-.77-2.165,3.21-2.034,1.629,1.621a9.318,9.318,0,0,1,2.441-.425l.986-2.074,3.708.832.006,2.3Zm-3.27,4.365a4.078,4.078,0,1,0,3.086,4.871A4.078,4.078,0,0,0,135.408,307.23Z",
    transform: "translate(1.942 0.523)",
    fill: "#097bed",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19683",
    "data-name": "Group 19683",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19682",
    "data-name": "Group 19682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19681",
    "data-name": "Group 19681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51850",
    "data-name": "Path 51850",
    d: "M138.678,302.865a9.348,9.348,0,0,1,2.026,1.427l2.164-.77,2.034,3.211-1.621,1.628a9.319,9.319,0,0,1,.426,2.441l2.074.986-.832,3.709-2.3.005a9.29,9.29,0,0,1-1.427,2.026l.771,2.164-3.211,2.035-1.628-1.621a9.332,9.332,0,0,1-2.442.425l-.985,2.074-3.71-.832,0-2.3a9.294,9.294,0,0,1-2.026-1.428l-2.165.771-2.034-3.211,1.621-1.628a9.324,9.324,0,0,1-.425-2.442l-2.074-.985.831-3.709,2.3-.005a9.29,9.29,0,0,1,1.427-2.026l-.77-2.165,3.21-2.034,1.629,1.621a9.318,9.318,0,0,1,2.441-.425l.986-2.074,3.708.832.006,2.3Zm-3.27,4.365a4.078,4.078,0,1,0,3.086,4.871A4.078,4.078,0,0,0,135.408,307.23Z",
    transform: "translate(1.942 0.523)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20558",
    "data-name": "Group 20558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19561",
    "data-name": "Group 19561",
    transform: "translate(6.61 533.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19541",
    "data-name": "Group 19541",
    transform: "translate(309.648 144.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19538",
    "data-name": "Group 19538",
    transform: "translate(0.432 0.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19497",
    "data-name": "Rectangle 19497",
    width: 240.408,
    height: 160.968,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19540",
    "data-name": "Group 19540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19539",
    "data-name": "Group 19539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51769",
    "data-name": "Path 51769",
    d: "M550.487,306.264s-.023-1.006-.036-2.929l-.038-8.492c-.022-7.45-.05-18.379-.088-32.374-.043-27.965-.106-68.165-.182-117.174l.344.344-240.389.088h-.018l.43-.432c-.013,57.346-.025,111.877-.036,160.969l-.394-.4,173.2.2,49.482.106c5.74.02,10.159.036,13.162.048l3.4.023c.766.008,1.167.023,1.167.023s-.369.015-1.12.023l-3.353.023-13.084.048-49.393.106-173.457.194-.4,0v-.4c-.01-49.092-.023-103.623-.036-160.969v-.43h.45l240.389.086h.346l0,.344c-.074,49.1-.137,89.37-.18,117.389-.038,13.96-.068,24.863-.088,32.3-.017,3.687-.03,6.508-.038,8.428C550.512,305.306,550.487,306.264,550.487,306.264Z",
    transform: "translate(-309.648 -144.865)",
    fill: "#097bed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19543",
    "data-name": "Group 19543",
    transform: "translate(310.08 159.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19542",
    "data-name": "Group 19542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51770",
    "data-name": "Path 51770",
    d: "M309.909,153.976c0-.238,53.777-.43,120.1-.43,66.344,0,120.109.192,120.109.43s-53.765.43-120.109.43C363.686,154.406,309.909,154.215,309.909,153.976Z",
    transform: "translate(-309.909 -153.546)",
    fill: "#097bed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19547",
    "data-name": "Group 19547",
    transform: "translate(315.711 150.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19544",
    "data-name": "Group 19544",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51771",
    "data-name": "Path 51771",
    d: "M317.166,150.19a1.927,1.927,0,1,1-1.928-1.928A1.927,1.927,0,0,1,317.166,150.19Z",
    transform: "translate(-313.312 -148.262)",
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19545",
    "data-name": "Group 19545",
    transform: "translate(6.602)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51772",
    "data-name": "Path 51772",
    d: "M321.154,150.19a1.926,1.926,0,1,1-1.926-1.928A1.926,1.926,0,0,1,321.154,150.19Z",
    transform: "translate(-317.302 -148.262)",
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19546",
    "data-name": "Group 19546",
    transform: "translate(13.109)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51773",
    "data-name": "Path 51773",
    d: "M325.088,150.19a1.927,1.927,0,1,1-1.926-1.928A1.926,1.926,0,0,1,325.088,150.19Z",
    transform: "translate(-321.234 -148.262)",
    fill: "#097bed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19548",
    "data-name": "Group 19548",
    transform: "translate(330.748 176.447)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19498",
    "data-name": "Rectangle 19498",
    width: 64.128,
    height: 64.129,
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19550",
    "data-name": "Group 19550",
    transform: "translate(405.801 194.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19549",
    "data-name": "Group 19549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51774",
    "data-name": "Path 51774",
    d: "M479.473,175.074c0,.238-25.01.432-55.857.432s-55.862-.194-55.862-.432,25.005-.43,55.862-.43S479.473,174.838,479.473,175.074Z",
    transform: "translate(-367.755 -174.644)",
    fill: "#0093ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19552",
    "data-name": "Group 19552",
    transform: "translate(405.801 206.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19551",
    "data-name": "Group 19551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51775",
    "data-name": "Path 51775",
    d: "M479.473,182.276c0,.238-25.01.43-55.857.43s-55.862-.192-55.862-.43,25.005-.43,55.862-.43S479.473,182.038,479.473,182.276Z",
    transform: "translate(-367.755 -181.846)",
    fill: "#0093ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19554",
    "data-name": "Group 19554",
    transform: "translate(405.801 217.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19553",
    "data-name": "Group 19553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51776",
    "data-name": "Path 51776",
    d: "M479.473,189.479c0,.237-25.01.43-55.857.43s-55.862-.194-55.862-.43,25.005-.432,55.862-.432S479.473,189.241,479.473,189.479Z",
    transform: "translate(-367.755 -189.047)",
    fill: "#0093ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19556",
    "data-name": "Group 19556",
    transform: "translate(405.801 229.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19555",
    "data-name": "Group 19555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51777",
    "data-name": "Path 51777",
    d: "M433.782,196.679a14.874,14.874,0,0,1-2.595.169l-7.074.136c-5.975.078-14.228.127-23.342.127s-17.373-.05-23.347-.127l-7.076-.136a14.862,14.862,0,0,1-2.593-.169,14.993,14.993,0,0,1,2.593-.167l7.076-.137c5.974-.078,14.228-.126,23.347-.126s17.367.048,23.342.126l7.074.137A15.006,15.006,0,0,1,433.782,196.679Z",
    transform: "translate(-367.755 -196.249)",
    fill: "#0093ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19557",
    "data-name": "Group 19557",
    transform: "translate(334.76 262.197)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19499",
    "data-name": "Rectangle 19499",
    width: 30.137,
    height: 30.138,
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19558",
    "data-name": "Group 19558",
    transform: "translate(389.416 262.197)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19500",
    "data-name": "Rectangle 19500",
    width: 30.137,
    height: 30.138,
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19559",
    "data-name": "Group 19559",
    transform: "translate(444.071 262.197)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19501",
    "data-name": "Rectangle 19501",
    width: 30.138,
    height: 30.138,
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19560",
    "data-name": "Group 19560",
    transform: "translate(498.726 262.197)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19502",
    "data-name": "Rectangle 19502",
    width: 30.138,
    height: 30.138,
    fill: "#097bed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19580",
    "data-name": "Group 19580",
    transform: "translate(43.99 243.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19565",
    "data-name": "Group 19565",
    transform: "translate(44.005 179.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19562",
    "data-name": "Group 19562",
    transform: "translate(0.451 0.45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19503",
    "data-name": "Rectangle 19503",
    width: 284.09,
    height: 115.393,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19564",
    "data-name": "Group 19564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19563",
    "data-name": "Group 19563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51778",
    "data-name": "Path 51778",
    d: "M328.545,295.807s-.02-.709-.031-2.061-.02-3.367-.035-5.986c-.018-5.266-.044-13-.079-22.965-.039-19.916-.1-48.724-.171-84.381l.316.316c-72.268.035-172.866.081-284.07.134h-.02l.45-.45c-.007,40.409-.013,79.415-.02,115.393l-.43-.43,203.687.2c25.223.051,45.3.092,59.089.119l15.813.055,4.094.026c.924.009,1.407.026,1.407.026s-.448.018-1.352.029q-1.389.007-4.043.026c-3.593.011-8.877.031-15.725.055-13.767.026-33.808.068-58.99.119l-203.979.2h-.43v-.432c-.007-35.977-.013-74.984-.02-115.393v-.45h.47c111.2.053,211.8.1,284.07.134h.318l0,.316c-.072,35.736-.13,64.612-.171,84.572-.033,9.935-.059,17.646-.077,22.895-.015,2.595-.026,4.577-.035,5.929C328.567,295.141,328.545,295.807,328.545,295.807Z",
    transform: "translate(-44.005 -179.964)",
    fill: "#097bed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19567",
    "data-name": "Group 19567",
    transform: "translate(44.74 195.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19566",
    "data-name": "Group 19566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51779",
    "data-name": "Path 51779",
    d: "M44.34,187.5c0-.25,63.5-.45,141.812-.45,78.34,0,141.828.2,141.828.45s-63.488.448-141.828.448C107.839,187.952,44.34,187.752,44.34,187.5Z",
    transform: "translate(-44.34 -187.054)",
    fill: "#097bed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19571",
    "data-name": "Group 19571",
    transform: "translate(52.509 186.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19568",
    "data-name": "Group 19568",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51780",
    "data-name": "Path 51780",
    d: "M52,185.211a2.062,2.062,0,1,1-2.061-2.063A2.063,2.063,0,0,1,52,185.211Z",
    transform: "translate(-47.879 -183.148)",
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19569",
    "data-name": "Group 19569",
    transform: "translate(7.066)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51781",
    "data-name": "Path 51781",
    d: "M55.22,185.211a2.061,2.061,0,1,1-2.061-2.063A2.061,2.061,0,0,1,55.22,185.211Z",
    transform: "translate(-51.098 -183.148)",
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19570",
    "data-name": "Group 19570",
    transform: "translate(14.029)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51782",
    "data-name": "Path 51782",
    d: "M58.395,185.211a2.062,2.062,0,1,1-2.063-2.063A2.063,2.063,0,0,1,58.395,185.211Z",
    transform: "translate(-54.27 -183.148)",
    fill: "#097bed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19572",
    "data-name": "Group 19572",
    transform: "translate(68.599 214.732)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19504",
    "data-name": "Rectangle 19504",
    width: 68.619,
    height: 68.619,
    fill: "#097bed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19579",
    "data-name": "Group 19579",
    transform: "translate(151.166 232.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19574",
    "data-name": "Group 19574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19573",
    "data-name": "Group 19573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51783",
    "data-name": "Path 51783",
    d: "M250.548,204.425c0,.248-35.312.45-78.86.45s-78.864-.2-78.864-.45,35.3-.45,78.864-.45S250.548,204.177,250.548,204.425Z",
    transform: "translate(-92.824 -203.975)",
    fill: "#097bed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19576",
    "data-name": "Group 19576",
    transform: "translate(0 13.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19575",
    "data-name": "Group 19575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51784",
    "data-name": "Path 51784",
    d: "M250.548,210.794c0,.248-35.312.45-78.86.45s-78.864-.2-78.864-.45,35.3-.45,78.864-.45S250.548,210.544,250.548,210.794Z",
    transform: "translate(-92.824 -210.344)",
    fill: "#097bed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19578",
    "data-name": "Group 19578",
    transform: "translate(0 27.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19577",
    "data-name": "Group 19577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51785",
    "data-name": "Path 51785",
    d: "M194.357,217.162a4.489,4.489,0,0,1-1.032.09l-2.957.086-10.881.143c-9.294.033-21.931.081-35.894.132-13.969-.05-26.606-.1-35.9-.132l-10.879-.143-2.957-.086a4.489,4.489,0,0,1-1.032-.09,4.49,4.49,0,0,1,1.032-.09c.773-.024,1.752-.051,2.957-.086l10.879-.143c9.3-.035,21.933-.081,35.9-.132,13.963.05,26.6.1,35.894.132l10.881.143c1.2.035,2.184.061,2.957.086A4.49,4.49,0,0,1,194.357,217.162Z",
    transform: "translate(-92.824 -216.712)",
    fill: "#097bed"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19531",
    "data-name": "Group 19531",
    transform: "translate(270.72 107.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19504",
    "data-name": "Group 19504",
    transform: "translate(102.133 23.261)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 77.691,
    cy: 77.691,
    r: 77.691,
    transform: "translate(0 109.872) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19506",
    "data-name": "Group 19506",
    transform: "translate(211.07 89.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19505",
    "data-name": "Group 19505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51752",
    "data-name": "Path 51752",
    d: "M199.027,106.079a15.633,15.633,0,0,1-2.745.181l-7.55.153c-6.409.088-15.336.149-25.412.165h-.5v-.5c0-1.612,0-3.312,0-5.039,0-11.254.056-21.441.147-28.816.065-3.554.118-6.5.16-8.732a19.358,19.358,0,0,1,.2-3.2,19.607,19.607,0,0,1,.2,3.2c.041,2.235.1,5.177.16,8.732.092,7.374.147,17.562.147,28.816,0,1.727,0,3.427,0,5.039l-.5-.5c10.076.016,19,.075,25.412.165,3.073.061,5.608.113,7.55.153A15.418,15.418,0,0,1,199.027,106.079Z",
    transform: "translate(-162.817 -60.29)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19508",
    "data-name": "Group 19508",
    transform: "translate(211.309 68.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19507",
    "data-name": "Group 19507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51753",
    "data-name": "Path 51753",
    d: "M163.453,48.3c.276,0,.5,2.923.5,6.525s-.226,6.527-.5,6.527-.5-2.923-.5-6.527S163.174,48.3,163.453,48.3Z",
    transform: "translate(-162.95 -48.296)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19510",
    "data-name": "Group 19510",
    transform: "translate(238.1 78.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19509",
    "data-name": "Group 19509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51754",
    "data-name": "Path 51754",
    d: "M186.984,54.141c.2.2-1.68,2.391-4.192,4.9s-4.709,4.391-4.9,4.193,1.68-2.391,4.193-4.9S186.789,53.944,186.984,54.141Z",
    transform: "translate(-177.874 -54.127)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19512",
    "data-name": "Group 19512",
    transform: "translate(256.908 101.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19511",
    "data-name": "Group 19511",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51755",
    "data-name": "Path 51755",
    d: "M199.351,66.745c.127.253-2.337,1.736-5.353,3.574s-5.472,3.335-5.639,3.106,2.054-2.109,5.116-3.965S199.231,66.5,199.351,66.745Z",
    transform: "translate(-188.351 -66.711)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19514",
    "data-name": "Group 19514",
    transform: "translate(262.241 134.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19513",
    "data-name": "Group 19513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51756",
    "data-name": "Path 51756",
    d: "M209.119,85.644c0,.278-3.983.5-8.9.5s-8.9-.224-8.9-.5,3.983-.5,8.9-.5S209.119,85.367,209.119,85.644Z",
    transform: "translate(-191.322 -85.141)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19516",
    "data-name": "Group 19516",
    transform: "translate(139.826 133.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19515",
    "data-name": "Group 19515",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51757",
    "data-name": "Path 51757",
    d: "M139.94,84.983c0,.278-3.763.5-8.4.5s-8.4-.224-8.4-.5,3.763-.5,8.4-.5S139.94,84.706,139.94,84.983Z",
    transform: "translate(-123.13 -84.48)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19518",
    "data-name": "Group 19518",
    transform: "translate(152.024 158.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19517",
    "data-name": "Group 19517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51758",
    "data-name": "Path 51758",
    d: "M143.265,98.682c.181.21-2.662,2.79-6.351,5.761s-6.816,5.2-6.981,4.978,2.677-2.8,6.351-5.761S143.082,98.472,143.265,98.682Z",
    transform: "translate(-129.925 -98.668)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19520",
    "data-name": "Group 19520",
    transform: "translate(177.958 177.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19519",
    "data-name": "Group 19519",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51759",
    "data-name": "Path 51759",
    d: "M153.309,109.44c.232.171-1.878,3.413-4.323,7.493s-4.33,7.459-4.588,7.335c-.242-.115,1.242-3.732,3.727-7.852S153.093,109.28,153.309,109.44Z",
    transform: "translate(-144.372 -109.434)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19522",
    "data-name": "Group 19522",
    transform: "translate(211.309 185.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19521",
    "data-name": "Group 19521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51760",
    "data-name": "Path 51760",
    d: "M163.453,131.2c-.278,0-.5-3.985-.5-8.9s.224-8.9.5-8.9.5,3.983.5,8.9S163.729,131.2,163.453,131.2Z",
    transform: "translate(-162.95 -113.403)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19524",
    "data-name": "Group 19524",
    transform: "translate(236.842 179.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19523",
    "data-name": "Group 19523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51761",
    "data-name": "Path 51761",
    d: "M190.5,121.858c-.142.224-3.624-1.777-7.339-5.026s-6.182-6.412-5.98-6.583c.217-.192,2.973,2.641,6.64,5.825S190.663,121.618,190.5,121.858Z",
    transform: "translate(-177.173 -110.24)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19526",
    "data-name": "Group 19526",
    transform: "translate(257.086 160.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19525",
    "data-name": "Group 19525",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51762",
    "data-name": "Path 51762",
    d: "M199.538,110.823c-.2.2-2.836-2.124-5.893-5.183s-5.378-5.7-5.183-5.892,2.835,2.122,5.893,5.181S199.734,110.625,199.538,110.823Z",
    transform: "translate(-188.451 -99.736)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19528",
    "data-name": "Group 19528",
    transform: "translate(154.843 100.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19527",
    "data-name": "Group 19527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51763",
    "data-name": "Path 51763",
    d: "M141.2,75.728c-.2.2-2.526-1.813-5.2-4.488s-4.687-5-4.49-5.2,2.524,1.815,5.2,4.49S141.395,75.532,141.2,75.728Z",
    transform: "translate(-131.496 -66.025)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19530",
    "data-name": "Group 19530",
    transform: "translate(177.236 76.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19529",
    "data-name": "Group 19529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51764",
    "data-name": "Path 51764",
    d: "M153.5,62.594c-.2.2-2.484-1.765-5.111-4.38s-4.6-4.9-4.4-5.091,2.484,1.763,5.113,4.378S153.693,62.4,153.5,62.594Z",
    transform: "translate(-143.97 -53.109)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19535",
    "data-name": "Group 19535",
    transform: "translate(67.893 -83.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51766",
    "data-name": "Path 51766",
    d: "M63.7,201.1h241.26s-21.336-38.824-83.438-33.172c-59.31,5.394-62.323-19.1-92.482-22.116S73.753,165.918,63.7,201.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19536",
    "data-name": "Group 19536",
    transform: "translate(1100.145 -111.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51767",
    "data-name": "Path 51767",
    d: "M223.8,343.26H484.245s-23.032-41.915-90.071-35.812c-64.029,5.824-67.282-20.618-99.841-23.876S234.65,305.277,223.8,343.26Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_19488",
    "data-name": "Group 19488",
    transform: "translate(635.145 18.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19483",
    "data-name": "Group 19483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19482",
    "data-name": "Group 19482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19481",
    "data-name": "Group 19481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19480",
    "data-name": "Group 19480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51744",
    "data-name": "Path 51744",
    d: "M424.438,132.173a4.781,4.781,0,0,1,1.5.469,6.307,6.307,0,0,1,2.986,3.021,6.393,6.393,0,0,1,.609,2.919,6.475,6.475,0,0,1-1,3.272,6.492,6.492,0,0,1-2.866,2.463,6.464,6.464,0,0,1-7.515-1.685,6.5,6.5,0,0,1-1.54-3.452,6.491,6.491,0,0,1,.49-3.387,6.379,6.379,0,0,1,1.8-2.379,6.3,6.3,0,0,1,3.99-1.457,4.777,4.777,0,0,1,1.554.216c-.007.044-.554-.11-1.551-.075a6.318,6.318,0,0,0-3.828,1.513,6.19,6.19,0,0,0-2.121,5.527,6.181,6.181,0,0,0,1.477,3.26,6.139,6.139,0,0,0,7.1,1.593,6.2,6.2,0,0,0,2.727-2.317,6.19,6.19,0,0,0,.443-5.9,6.314,6.314,0,0,0-2.815-3C424.987,132.31,424.425,132.216,424.438,132.173Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19487",
    "data-name": "Group 19487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19486",
    "data-name": "Group 19486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19485",
    "data-name": "Group 19485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19484",
    "data-name": "Group 19484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51745",
    "data-name": "Path 51745",
    d: "M429.52,125.391a1.264,1.264,0,0,1-.014-.222c0-.166-.009-.388-.016-.676-.008-.619-.021-1.512-.037-2.671l.046.057-5.771-1.259.1-.051-1.518,3.23-.027.058-.065,0a14.435,14.435,0,0,0-3.762.667l-.069.022-.052-.051-2.537-2.512.161.018-4.982,3.172.058-.169c.373,1.041.784,2.187,1.2,3.361l.031.086-.062.067a14.349,14.349,0,0,0-2.189,3.118l-.044.085h-.1l-3.568.013.157-.127c-.4,1.811-.839,3.764-1.285,5.765l-.093-.19,3.225,1.528.094.045.005.105a14.4,14.4,0,0,0,.655,3.747l.032.1-.075.076-2.518,2.531.024-.221,3.164,4.989-.214-.074,3.364-1.2.1-.037.08.075a14.332,14.332,0,0,0,3.106,2.188h0c.044.072-.1-.16.1.161v1.79c0,.6,0,1.189,0,1.779l-.142-.177,5.764,1.294-.2.1,1.532-3.223.046-.1.108,0a14.283,14.283,0,0,0,3.748-.65l.1-.032.075.075,2.528,2.521-.215-.023,4.992-3.156-.068.2-1.193-3.365-.033-.093.067-.072a14.292,14.292,0,0,0,2.2-3.11l.045-.085h.1l3.568,0-.147.119c.459-2.027.892-3.94,1.3-5.761l.076.156-3.22-1.539-.072-.034,0-.079a14.4,14.4,0,0,0-.644-3.763l-.022-.069.051-.051,2.528-2.521-.015.133-3.139-5,.1.033-3.371,1.175-.034.012-.025-.024a14.946,14.946,0,0,0-2.292-1.765l-.614-.37a1.552,1.552,0,0,1-.2-.125,1.9,1.9,0,0,1,.217.1c.141.072.354.182.63.345a14.025,14.025,0,0,1,2.34,1.731l-.059-.012L436,126.334l.061-.022.036.055,3.183,4.976.046.072-.061.062-2.51,2.538.029-.12a14.63,14.63,0,0,1,.677,3.824l-.074-.113,3.227,1.524.1.047-.025.109c-.4,1.823-.83,3.737-1.281,5.766l-.026.117h-.122l-3.568.014.139-.085a14.611,14.611,0,0,1-2.238,3.186l.034-.165,1.2,3.362.045.126-.113.071-4.986,3.166-.117.074-.1-.1-2.532-2.517.177.043a14.636,14.636,0,0,1-3.84.67l.154-.1-1.529,3.224-.062.13-.14-.031-5.764-1.291-.142-.032v-.145l0-1.779,0-.895v-.9c.2.322.054.089.1.161h0a14.652,14.652,0,0,1-3.184-2.244l.184.038-3.364,1.2-.136.049-.078-.122c-1.086-1.717-2.158-3.411-3.159-4.991l-.076-.12.1-.1,2.521-2.528-.043.177a14.735,14.735,0,0,1-.666-3.84l.1.149-3.222-1.534-.122-.058.03-.132,1.3-5.762.029-.126h.129l3.568,0-.138.085a14.6,14.6,0,0,1,2.247-3.178l-.032.152c-.416-1.176-.822-2.324-1.19-3.366l-.039-.108.1-.061,5-3.149.088-.056.073.074,2.523,2.526-.12-.029a14.6,14.6,0,0,1,3.825-.654l-.092.061,1.544-3.217.032-.067.071.017,5.756,1.326.046.01v.046c-.01,1.149-.018,2.033-.024,2.647-.005.292-.01.517-.013.685A1.9,1.9,0,0,1,429.52,125.391Z",
    fill: "#e0e0e0"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20268",
    "data-name": "Group 20268",
    transform: "translate(-78 640.35)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52328",
    "data-name": "Path 52328",
    d: "M181.76,429.2a47.64,47.64,0,0,1-4.02,10.45H78V113.19a170.376,170.376,0,0,1,35.57,12.51c24.22,12.01,45.4,33.29,50.3,59.87,3.52,19.09-1.59,38.73-8.55,56.85s-15.86,35.6-20.42,54.47-4.28,39.98,6.22,56.3c9.42,14.64,25.85,23.73,34.95,38.57A49.291,49.291,0,0,1,181.76,429.2Z",
    fill: "#48bfd7",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20267",
    "data-name": "Group 20267",
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 91.963,
    cy: 91.963,
    r: 91.963,
    transform: "translate(278.741 245.796) rotate(-45)",
    fill: "#48bfd7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 63.155,
    cy: 63.155,
    r: 63.155,
    transform: "translate(234.535 287.899) rotate(-45)",
    fill: "#48bfd7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/lightMode.42cf6a724552125ebf9beaaa98d98e24.svg";
export { ForwardRef as ReactComponent };